import imgVip1 from '@/assets/images/vip.png';
import imgVip2 from '@/assets/images/souxitiyanguan.png';
import imgVip3 from '@/assets/images/vip.png';
import imgVip4 from '@/assets/images/gaojivip.png';
import imgVip5 from '@/assets/images/souxitiyanguan.png';
// export const STORE_ANDROID = 'https://sj.qq.com/myapp/detail.htm?apkName=cn.iiibest.app'; // android应用商店(应用宝)
export const STORE_ANDROID = 'https://sj.qq.com/appdetail/com.cfmoto'; // android应用商店(应用宝)
export const STORE_APPLE = 'https://itunes.apple.com/cn/app/id1537352180?mt=8'; // 苹果应用商店

export const STORE_ANDROID_ID = 'com.cfmoto';
export const STORE_APPLE_ID = '1537352180';
export const STORE_HARMONY_ID = 'com.zeeho.zeeho';

export const AVATAR_TAGS = {
  1: imgVip1,
  2: imgVip2,
  3: imgVip3,
  4: imgVip4,
  5: imgVip5,
};

export const EVENTS = {
  ID_10001: 10001, // 模拟车主
  ID_10002: 10002, // 地图
  ID_10003: 10003, // 人车页车辆图片
  ID_10004: 10004, // 寻车
  ID_10005: 10005, // （解锁）左滑
  ID_10006: 10006, // （解锁）右滑
  ID_10007: 10007, // 车辆体检
  ID_10008: 10008, // 车辆设置
  ID_10009: 10009, // 使用指南
  ID_10010: 10010, // OTA升级
  ID_10011: 10011, // 防盗功能
  ID_10012: 10012, // 开始检测
  ID_10013: 10013, // 简易骑行
  ID_10014: 10014, // 离车关机时间
  ID_10015: 10015, // 低电量提醒
  ID_10016: 10016, // 仪表设置
  ID_10459: 10459, // TCS 牵引力控制系统
  ID_10460: 10460, // 离车关机时间（带开关）
  ID_10461: 10461, // 静态音效
  ID_10462: 10462, // 自动定速巡航
  ID_10463: 10463, // 感应解锁
  ID_10470: 10470, // 模式切换
  ID_10474: 10474, // 解锁上锁
  ID_10489: 10489, // 骑行音效
  ID_10490: 10490, // 防盗音效
  ID_10491: 10491, // 变更动能回收类型
  ID_10492: 10492, // 开关自动驻车
  ID_10493: 10493, // 变更震动感应类型
  ID_10494: 10494, // 创建智能中控快捷方式
  ID_10495: 10495, // 坐垫传感器开关
  ID_10507: 10507, // 分享用车人
  ID_10508: 10508, // 蓝牙解锁失败
  ID_10509: 10509, // 长按解锁
  ID_10510: 10510, // 长按关锁
  ID_10511: 10511, // 寻车
  ID_10512: 10512, // 查看车辆定位
  ID_10017: 10017, // 电子围栏
  ID_10018: 10018, // 节日音效
  ID_10019: 10019, // 排行榜
  ID_10020: 10020, // 历史轨迹
  ID_10021: 10021, // 骑行分析
  ID_10022: 10022, // 新手视频指导
  ID_10023: 10023, // 车辆使用说明
  ID_10024: 10024, // 常见问题
  ID_10025: 10025, // 立即升级
  ID_10026: 10026, // 预约升级
  ID_10027: 10027, // 开启远程锁车
  ID_10028: 10028, // 关闭远程锁车
  ID_10029: 10029, // 防盗-获取验证码
  ID_10030: 10030, // 防盗-确定开启
  ID_10031: 10031, // 防盗-确定关闭
  ID_10032: 10032, // 解除绑定
  ID_10033: 10033, // 添加用车人
  ID_10034: 10034, // 极车页车辆图片
  ID_10035: 10035, // 预约试驾
  ID_10036: 10036, // 我的骑行-查看详情
  ID_10037: 10037, // 极车-立即购买
  ID_10038: 10038, // 整车详情-立即下单——整车详情埋点BO
  ID_10039: 10039, // 整车详情-选择版本——整车详情埋点BO
  ID_10040: 10040, // 整车详情-选择颜色——整车详情埋点BO
  ID_10041: 10041, // 整车详情-选择颜色-立即下单——整车详情埋点BO
  ID_10042: 10042, // 整车详情-去支付——整车详情埋点BO
  ID_10043: 10043, // 整车详情-收藏按钮——整车详情埋点BO
  ID_10044: 10044, // 整车详情-客服按钮——整车详情埋点BO
  ID_10045: 10045, // 整车详情-分享（微信）——整车详情埋点BO
  ID_10046: 10046, // 发布
  ID_10047: 10047, // 发布动态
  ID_10048: 10048, // 发布文章
  ID_10049: 10049, // 活动帖子详情——帖子埋点BO
  ID_10050: 10050, // 活动帖子列表-点赞——帖子埋点BO
  ID_10051: 10051, // 活动帖子详情-点赞——帖子埋点BO
  ID_10052: 10052, // 活动帖子详情-评论按钮——帖子埋点BO
  ID_10053: 10053, // 活动活动列表-关注——帖子埋点BO
  ID_10054: 10054, // 活动帖子详情-关注——帖子埋点BO
  ID_10055: 10055, // 活动单帖评论-回复——帖子埋点BO
  ID_10056: 10056, // 活动帖-详情页-分享（微信）——帖子埋点BO
  ID_10057: 10057, // 即刻-帖子详情——帖子埋点BO
  ID_10058: 10058, // 即刻-帖子列表-点赞——帖子埋点BO
  ID_10059: 10059, // 即刻-帖子详情点赞——帖子埋点BO
  ID_10060: 10060, // 即刻-帖子详情评论——帖子埋点BO
  ID_10061: 10061, // 即刻-帖子列表-作者头像——帖子埋点BO
  ID_10062: 10062, // 即刻-帖子详情-作者头像——帖子埋点BO
  ID_10063: 10063, // 即刻-帖子列表-关注——帖子埋点BO
  ID_10064: 10064, // 即刻-帖子详情-关注——帖子埋点BO
  ID_10065: 10065, // 即刻-帖子-详情页-分享渠道（微信）——帖子埋点BO
  ID_10066: 10066, // 即刻-单帖评论-回复——帖子埋点BO
  ID_10067: 10067, // 热点-帖子详情——帖子埋点BO
  ID_10068: 10068, // 热点-帖子列表-点赞——帖子埋点BO
  ID_10069: 10069, // 热点-帖子列表-评论——帖子埋点BO
  ID_10070: 10070, // 热点-作者头像按钮
  ID_10071: 10071, // 热点-关注按钮
  ID_10072: 10072, // 热点-感兴趣的人跳转按钮
  ID_10073: 10073, // 热点-感兴趣的人-关注按钮
  ID_10074: 10074, // 热点-帖子-详情页-分享渠道（微信）——帖子埋点BO
  ID_10075: 10075, // 热点-单帖评论-回复——帖子埋点BO
  ID_10076: 10076, // 热点-专栏1——帖子埋点BO
  ID_10077: 10077, // 资讯-帖子详情按钮——帖子埋点BO
  ID_10078: 10078, // 资讯-帖子列表-点赞——帖子埋点BO
  ID_10079: 10079, // 资讯--帖子列表-评论——帖子埋点BO
  ID_10080: 10080, // 资讯-作者头像按钮——帖子埋点BO
  ID_10081: 10081, // 资讯-个人主页-关注按钮——帖子埋点BO
  ID_10082: 10082, // 资讯-帖子详情页-帖子收藏——帖子埋点BO
  ID_10083: 10083, // 资讯-帖子详情页-帖子点赞——帖子埋点BO
  ID_10084: 10084, // 资讯-帖子详情页-评论点赞——帖子埋点BO
  ID_10085: 10085, // 资讯-帖子详情页-评论回复——帖子埋点BO
  ID_10086: 10086, // 资讯-帖子详情页-分享渠道（微信）——帖子埋点BO
  ID_10087: 10087, // 搜索按钮
  ID_10088: 10088, // 热门搜索
  ID_10089: 10089, // 极市购物车按钮
  ID_10090: 10090, // 极市购物车-商品——极市商品详情埋点BO
  ID_10091: 10091, // 极市-banner——banner埋点BO
  ID_10092: 10092, // 极市-商品列表-商品——极市商品详情埋点BO
  ID_10093: 10093, // 极市-商品详情-购物车——极市商品详情埋点BO
  ID_10094: 10094, // 极市商品详情-分享渠道按钮（微信）——极市商品详情埋点BO
  ID_10095: 10095, // 极市商品详情-客服按钮——极市商品详情埋点BO
  ID_10096: 10096, // 极市商品详情-加入购物车——极市商品详情埋点BO
  ID_10097: 10097, // 极市商品详情-立即购买——极市商品详情埋点BO
  ID_10098: 10098, // 极市商品详情-立即购买-立即购买-选择规格——极市商品详情埋点BO
  ID_10099: 10099, // 极市商品详情-立即购买-立即购买-立即下单——极市商品详情埋点BO
  ID_10100: 10100, // 极市商品详情-立即购买-立即购买-立即下单-立即支付——极市商品详情埋点BO
  ID_10101: 10101, // 个人主页-举报
  ID_10102: 10102, // 个人主页-拉黑
  ID_10103: 10103, // 个人主页-取消关注
  ID_10104: 10104, // 通讯录按钮
  ID_10105: 10105, // 消息通知按钮
  ID_10106: 10106, // 系统通知
  ID_10107: 10107, // 互动消息
  ID_10108: 10108, // 车辆消息
  ID_10109: 10109, // 交易消息
  ID_10110: 10110, // 互动消息-回复帖子
  ID_10111: 10111, // 系统通知开关
  ID_10112: 10112, // 互动消息开关
  ID_10113: 10113, // 车辆消息开关
  ID_10114: 10114, // 交易消息开关
  ID_10115: 10115, // 单个帖子——帖子埋点BO
  ID_10116: 10116, // 关于APP-下载安装按钮
  ID_10117: 10117, // 我的APP首页设置成功
  ID_10118: 10118, // 消息通知
  ID_10119: 10119, // 紧急联系人
  ID_10120: 10120, // 我的车库
  ID_10121: 10121, // 商城订单
  ID_10122: 10122, // 金融分期订单
  ID_10123: 10123, // 盗抢订单
  ID_10124: 10124, // 商城订单-客服咨询
  ID_10125: 10125, // 商城订单-取消订单
  ID_10126: 10126, // 商城订单-立即付款
  ID_10127: 10127, // 我的收藏
  ID_10128: 10128, // 整车详情-分享（朋友圈）——整车详情埋点BO
  ID_10129: 10129, // 整车详情-分享（qq）——整车详情埋点BO
  ID_10130: 10130, // 整车详情-分享（微博）——整车详情埋点BO
  ID_10131: 10131, // 整车详情-分享（钉钉）——整车详情埋点BO
  ID_10132: 10132, // 整车详情-分享（好友）——整车详情埋点BO
  ID_10133: 10133, // 活动帖-详情页-分享（朋友圈）——帖子埋点BO
  ID_10134: 10134, // 活动帖-详情页-分享（qq）——帖子埋点BO
  ID_10135: 10135, // 活动帖-详情页-分享（微博）——帖子埋点BO
  ID_10136: 10136, // 活动帖-详情页-分享（钉钉）——帖子埋点BO
  ID_10137: 10137, // 活动帖-详情页-分享（好友）——帖子埋点BO
  ID_10138: 10138, // 即刻-帖子-详情页-分享渠道（朋友圈）——帖子埋点BO
  ID_10139: 10139, // 即刻-帖子-详情页-分享渠道（qq）——帖子埋点BO
  ID_10140: 10140, // 即刻-帖子-详情页-分享渠道（微博）——帖子埋点BO
  ID_10141: 10141, // 即刻-帖子-详情页-分享渠道（钉钉）——帖子埋点BO
  ID_10142: 10142, // 即刻-帖子-详情页-分享渠道（好友）——帖子埋点BO
  ID_10143: 10143, // 即刻-帖子-详情页-分享渠道（举报成功页的举报）——帖子埋点BO
  ID_10144: 10144, // 即刻-帖子-详情页-分享渠道（屏蔽）——帖子埋点BO
  ID_10145: 10145, // 热点-帖子-详情页-分享渠道（朋友圈）——帖子埋点BO
  ID_10146: 10146, // 热点-帖子-详情页-分享渠道（qq）——帖子埋点BO
  ID_10147: 10147, // 热点-帖子-详情页-分享渠道（微博）——帖子埋点BO
  ID_10148: 10148, // 热点-帖子-详情页-分享渠道（钉钉）——帖子埋点BO
  ID_10149: 10149, // 热点-帖子-详情页-分享渠道（好友）——帖子埋点BO
  ID_10150: 10150, // 热点-帖子-详情页-分享渠道（举报成功页的举报）——帖子埋点BO
  ID_10151: 10151, // 热点-帖子-详情页-分享渠道（屏蔽）——帖子埋点BO
  ID_10152: 10152, // 资讯-帖子详情页-分享渠道（朋友圈）——帖子埋点BO
  ID_10153: 10153, // 资讯-帖子详情页-分享渠道（qq）——帖子埋点BO
  ID_10154: 10154, // 资讯-帖子详情页-分享渠道（微博）——帖子埋点BO
  ID_10155: 10155, // 资讯-帖子详情页-分享渠道（钉钉）——帖子埋点BO
  ID_10156: 10156, // 资讯-帖子详情页-分享渠道（好友）——帖子埋点BO
  ID_10157: 10157, // 资讯-帖子详情页-分享渠道（举报成功页的举报）——帖子埋点BO
  ID_10158: 10158, // 资讯-帖子详情页-分享渠道（屏蔽）——帖子埋点BO
  ID_10159: 10159, // 极市商品详情-分享渠道按钮（朋友圈）——极市商品详情埋点BO
  ID_10160: 10160, // 极市商品详情-分享渠道按钮（qq）——极市商品详情埋点BO
  ID_10161: 10161, // 极市商品详情-分享渠道按钮（微博）——极市商品详情埋点BO
  ID_10162: 10162, // 极市商品详情-分享渠道按钮（钉钉）——极市商品详情埋点BO
  ID_10163: 10163, // 极市商品详情-分享渠道按钮（好友）——极市商品详情埋点BO
  ID_10164: 10164, // 热点-专栏2——帖子埋点BO
  ID_10165: 10165, // 商品详情——整车商品详情埋点BO
  ID_10166: 10166, // 回到爱车
  ID_10167: 10167, // 绑定车辆
  ID_10168: 10168, // 车型——车型名称埋点BO
  ID_10169: 10169, // 消息中心
  ID_10170: 10170, // 整车详情-查看门店——整车详情埋点BO
  ID_10171: 10171, // 整车详情-金融分期——整车详情埋点BO
  ID_10172: 10172, // 整车详情-选择配置-立即下单——整车详情埋点BO
  ID_10173: 10173, // 整车详情-暂时放弃——整车详情埋点BO
  ID_10174: 10174, // 整车详情-继续支付——整车详情埋点BO
  ID_10175: 10175, // 整车详情-待支付-确定——整车详情埋点BO
  ID_10176: 10176, // 整车详情-待支付-关闭——整车详情埋点BO
  ID_10177: 10177, // 长按解锁
  ID_10178: 10178, // 长按关锁
  ID_10179: 10179, // 品牌车型
  ID_10180: 10180, // 骑行记忆模式
  ID_10181: 10181, // 充电功率可调
  ID_10182: 10182, // 车辆音效控制
  ID_10183: 10183, // 保养里程重置
  ID_10184: 10184, // 首页充电显示时间去除
  ID_10185: 10185, // Motoplay
  ID_10186: 10186, // 预约保养
  ID_10187: 10187, // 故障报修
  ID_10188: 10188, // 失窃上报
  ID_10189: 10189, // 官方客服
  ID_10190: 10190, // 极智服务banner——banner埋点BO
  ID_10191: 10191, // 活动帖子列表取消点赞——帖子埋点BO
  ID_10192: 10192, // 活动帖子列表-分享——帖子埋点BO
  ID_10193: 10193, // 活动帖子列表-评论——帖子埋点BO
  ID_10194: 10194, // 活动帖子列表-自动评论——帖子埋点BO
  ID_10195: 10195, // 活动帖子详情-取消点赞——帖子埋点BO
  ID_10196: 10196, // 活动帖子详情-评论输入框——帖子埋点BO
  ID_10197: 10197, // 活动-评论列表-回复——帖子埋点BO
  ID_10198: 10198, // 即刻帖子列表-取消点赞——帖子埋点BO
  ID_10199: 10199, // 即刻帖子列表-分享——帖子埋点BO
  ID_10200: 10200, // 即刻帖子列表-评论——帖子埋点BO
  ID_10201: 10201, // 即刻帖子列表-自动评论——帖子埋点BO
  ID_10202: 10202, // 即刻-帖子详情-取消点赞——帖子埋点BO
  ID_10203: 10203, // 即刻-帖子详情-评论输入框——帖子埋点BO
  ID_10204: 10204, // 即刻-评论列表-回复——帖子埋点BO
  ID_10205: 10205, // 热点-帖子列表-取消点赞——帖子埋点BO
  ID_10206: 10206, // 热点帖子列表-自动评论——帖子埋点BO
  ID_10207: 10207, // 热点-感兴趣的人-回粉按钮——帖子埋点BO
  ID_10208: 10208, // 热点-帖子详情-点赞——帖子埋点BO
  ID_10209: 10209, // 热点-帖子详情-取消点赞——帖子埋点BO
  ID_10210: 10210, // 热点-帖子详情-评论——帖子埋点BO
  ID_10211: 10211, // 热点-帖子详情-评论输入框——帖子埋点BO
  ID_10212: 10212, // 热点-帖子详情-作者头像——帖子埋点BO
  ID_10213: 10213, // 热点-帖子详情-关注——帖子埋点BO
  ID_10214: 10214, // 热点-评论列表-回复——帖子埋点BO
  ID_10215: 10215, // 资讯-帖子列表-取消点赞——帖子埋点BO
  ID_10216: 10216, // 资讯帖子列表-自动评论——帖子埋点BO
  ID_10217: 10217, // 资讯-帖子详情页-取消点赞——帖子埋点BO
  ID_10218: 10218, // 资讯-帖子详情页-评论取消点赞——帖子埋点BO
  ID_10219: 10219, // 资讯-评论列表-回复——帖子埋点BO
  ID_10220: 10220, // 极市商品详情-暂时放弃——极市商品详情埋点BO
  ID_10221: 10221, // 极市商品详情-继续支付——极市商品详情埋点BO
  ID_10222: 10222, // 极市商品详情待支付-确定——极市商品详情埋点BO
  ID_10223: 10223, // 极市商品详情-待支付-关闭——极市商品详情埋点BO
  ID_10224: 10224, // 我的-发帖
  ID_10225: 10225, // 我的-关注
  ID_10226: 10226, // 我的-粉丝
  ID_10227: 10227, // 可用积分
  ID_10228: 10228, // 签到
  ID_10229: 10229, // 他人个人主页-关注
  ID_10230: 10230, // 他人个人主页-回粉
  ID_10231: 10231, // 他人个人主页-聊天
  ID_10232: 10232, // 他人个人主页-举报
  ID_10233: 10233, // 他人个人主页-拉黑
  ID_10234: 10234, // 他人个人主页-取消关注
  ID_10235: 10235, // 他人个人主页-他的粉丝
  ID_10236: 10236, // 他人个人主页-关注列表-关注
  ID_10237: 10237, // 他人个人主页-关注列表-回粉
  ID_10238: 10238, // 他人个人主页-关注列表-聊天
  ID_10239: 10239, // 他人个人主页-粉丝列表-关注
  ID_10240: 10240, // 他人个人主页-粉丝列表-回粉
  ID_10241: 10241, // 他人个人主页-粉丝列表-聊天
  ID_10242: 10242, // 他人个人主页-发帖列表-帖子详情——帖子埋点BO
  ID_10243: 10243, // 他人个人主页-发帖列表-点赞——帖子埋点BO
  ID_10244: 10244, // 他人个人主页-发帖列表-取消点赞——帖子埋点BO
  ID_10245: 10245, // 他人个人主页-发帖列表-分享——帖子埋点BO
  ID_10246: 10246, // 他人个人主页-发帖列表-评论——帖子埋点BO
  ID_10247: 10247, // 他人个人主页-发帖-帖子详情-点赞——帖子埋点BO
  ID_10248: 10248, // 他人个人主页-发帖-帖子详情-取消点赞——帖子埋点BO
  ID_10249: 10249, // 他人个人主页-发帖-帖子详情-帖子详情评论——帖子埋点BO
  ID_10250: 10250, // 他人个人主页-发帖-帖子详情--评论输入框——帖子埋点BO
  ID_10251: 10251, // 他人个人主页-发帖-帖子详情-分享渠道（微信）——帖子埋点BO
  ID_10252: 10252, // 他人个人主页-发帖-帖子详情-分享渠道（朋友圈）——帖子埋点BO
  ID_10253: 10253, // 他人个人主页-发帖-帖子详情-分享渠道（qq）——帖子埋点BO
  ID_10254: 10254, // 他人个人主页-发帖-帖子详情-分享渠道（微博）——帖子埋点BO
  ID_10255: 10255, // 他人个人主页-发帖-帖子详情-分享渠道（钉钉）——帖子埋点BO
  ID_10256: 10256, // 他人个人主页-发帖-帖子详情-分享渠道（好友）——帖子埋点BO
  ID_10257: 10257, // 他人个人主页-发帖-帖子详情-分享渠道（举报成页的举报）——帖子埋点BO
  ID_10258: 10258, // 他人个人主页-发帖-帖子详情-分享渠道（屏蔽）——帖子埋点BO
  ID_10259: 10259, // 他人个人主页-发帖-评论列表-回复——帖子埋点BO
  ID_10260: 10260, // 他人个人主页-他的关注
  ID_10261: 10261, // 音效开关
  ID_10262: 10262, // 低速音效
  ID_10263: 10263, // 座椅音效
  ID_10264: 10264, // 骑行模式音效
  ID_10265: 10265, // 边撑音效
  ID_10266: 10266, // READY音效
  ID_10267: 10267, // 自动关机倒数音效
  ID_10268: 10268, // 定速巡航音效
  ID_10269: 10269, // 资讯-帖子详情页-评论
  ID_10270: 10270, // 资讯-帖子详情页-评论输入框
  ID_10356: 10356, // 即刻-帖子列表-视频详情——帖子埋点BO
  ID_10357: 10357, // 即刻-帖子列表-视频详情-点赞——帖子埋点BO
  ID_10358: 10358, // 即刻-帖子列表-视频详情-取消点赞——帖子埋点BO
  ID_10359: 10359, // 即刻-帖子列表-视频详情-评论——帖子埋点BO
  ID_10360: 10360, // 即刻-帖子列表-视频详情-评论输入框——帖子埋点BO
  ID_10361: 10361, // 即刻-帖子列表-视频详情-评论回复——帖子埋点BO
  ID_10362: 10362, // 即刻-帖子列表-视频详情-分享渠道（微信）——帖子埋点BO
  ID_10363: 10363, // 即刻-帖子列表-视频详情-分享渠道（朋友圈）——帖子埋点BO
  ID_10364: 10364, // 即刻-帖子列表-视频详情-分享渠道（qq）——帖子埋点BO
  ID_10365: 10365, // 即刻-帖子列表-视频详情-分享渠道（微博）——帖子埋点BO
  ID_10366: 10366, // 即刻-帖子列表-视频详情-分享渠道（钉钉）——帖子埋点BO
  ID_10367: 10367, // 即刻-帖子列表-视频详情-分享渠道（好友）——帖子埋点BO
  ID_10368: 10368, // 即刻-帖子列表-视频详情-分享渠道（举报成页的举报）——帖子埋点BO
  ID_10369: 10369, // 即刻-帖子列表-视频详情-分享渠道（屏蔽）——帖子埋点BO
  ID_10370: 10370, // 即刻-帖子详情-视频详情——帖子埋点BO
  ID_10371: 10371, // 即刻-帖子详情-视频详情-点赞——帖子埋点BO
  ID_10372: 10372, // 即刻-帖子详情-视频详情-取消点赞——帖子埋点BO
  ID_10373: 10373, // 即刻-帖子详情-视频详情-评论——帖子埋点BO
  ID_10374: 10374, // 即刻-帖子详情-视频详情-评论输入框——帖子埋点BO
  ID_10375: 10375, // 即刻-帖子详情-视频详情-评论回复——帖子埋点BO
  ID_10376: 10376, // 即刻-帖子详情-视频详情-分享渠道（微信）——帖子埋点BO
  ID_10377: 10377, // 即刻-帖子详情-视频详情-分享渠道（朋友圈）——帖子埋点BO
  ID_10378: 10378, // 即刻-帖子详情-视频详情-分享渠道（qq）——帖子埋点BO
  ID_10379: 10379, // 即刻-帖子详情-视频详情-分享渠道（微博）——帖子埋点BO
  ID_10380: 10380, // 即刻-帖子详情-视频详情-分享渠道（钉钉）——帖子埋点BO
  ID_10381: 10381, // 即刻-帖子详情-视频详情-分享渠道（好友）——帖子埋点BO
  ID_10382: 10382, // 即刻-帖子详情-视频详情-分享渠道（举报成页的举报）——帖子埋点BO
  ID_10383: 10383, // 即刻-帖子详情-视频详情-分享渠道（屏蔽）——帖子埋点BO
  ID_10384: 10384, // 热点-帖子列表-视频详情——帖子埋点BO
  ID_10385: 10385, // 热点-帖子列表-视频详情-点赞——帖子埋点BO
  ID_10386: 10386, // 热点-帖子列表-视频详情-取消点赞——帖子埋点BO
  ID_10387: 10387, // 热点-帖子列表-视频详情-评论——帖子埋点BO
  ID_10388: 10388, // 热点-帖子列表-视频详情-评论输入框——帖子埋点BO
  ID_10389: 10389, // 热点-帖子列表-视频详情-评论回复——帖子埋点BO
  ID_10390: 10390, // 热点-帖子列表-视频详情-分享渠道（微信）——帖子埋点BO
  ID_10391: 10391, // 热点-帖子列表-视频详情-分享渠道（朋友圈）——帖子埋点BO
  ID_10392: 10392, // 热点-帖子列表-视频详情-分享渠道（qq）——帖子埋点BO
  ID_10393: 10393, // 热点-帖子列表-视频详情-分享渠道（微博）——帖子埋点BO
  ID_10394: 10394, // 热点-帖子列表-视频详情-分享渠道（钉钉）——帖子埋点BO
  ID_10395: 10395, // 热点-帖子列表-视频详情-分享渠道（好友）——帖子埋点BO
  ID_10396: 10396, // 热点-帖子列表-视频详情-分享渠道（举报成页的举报）——帖子埋点BO
  ID_10397: 10397, // 热点-帖子列表-视频详情-分享渠道（屏蔽）——帖子埋点BO
  ID_10398: 10398, // 热点-帖子详情-视频详情——帖子埋点BO
  ID_10399: 10399, // 热点-帖子详情-视频详情-点赞——帖子埋点BO
  ID_10400: 10400, // 热点-帖子详情-视频详情-取消点赞——帖子埋点BO
  ID_10401: 10401, // 热点-帖子详情-视频详情-评论——帖子埋点BO
  ID_10402: 10402, // 热点-帖子详情-视频详情-评论输入框——帖子埋点BO
  ID_10403: 10403, // 热点-帖子详情-视频详情-评论回复——帖子埋点BO
  ID_10404: 10404, // 热点-帖子详情-视频详情-分享渠道（微信）——帖子埋点BO
  ID_10405: 10405, // 热点-帖子详情-视频详情-分享渠道（朋友圈）——帖子埋点BO
  ID_10406: 10406, // 热点-帖子详情-视频详情-分享渠道（qq）——帖子埋点BO
  ID_10407: 10407, // 热点-帖子详情-视频详情-分享渠道（微博）——帖子埋点BO
  ID_10408: 10408, // 热点-帖子详情-视频详情-分享渠道（钉钉）——帖子埋点BO
  ID_10409: 10409, // 热点-帖子详情-视频详情-分享渠道（好友）——帖子埋点BO
  ID_10410: 10410, // 热点-帖子详情-视频详情-分享渠道（举报成页的举报）——帖子埋点BO
  ID_10411: 10411, // 热点-帖子详情-视频详情-分享渠道（屏蔽）——帖子埋点BO
  ID_10412: 10412, // 资讯-帖子列表-视频详情——帖子埋点BO
  ID_10413: 10413, // 资讯-帖子列表-视频详情-点赞——帖子埋点BO
  ID_10414: 10414, // 资讯-帖子列表-视频详情-取消点赞——帖子埋点BO
  ID_10415: 10415, // 资讯-帖子列表-视频详情-评论——帖子埋点BO
  ID_10416: 10416, // 资讯-帖子列表-视频详情-评论输入框——帖子埋点BO
  ID_10417: 10417, // 资讯-帖子列表-视频详情-评论回复——帖子埋点BO
  ID_10418: 10418, // 资讯-帖子列表-视频详情-分享渠道（微信）——帖子埋点BO
  ID_10419: 10419, // 资讯-帖子列表-视频详情-分享渠道（朋友圈）——帖子埋点BO
  ID_10420: 10420, // 资讯-帖子列表-视频详情-分享渠道（qq）——帖子埋点BO
  ID_10421: 10421, // 资讯-帖子列表-视频详情-分享渠道（微博）——帖子埋点BO
  ID_10422: 10422, // 资讯-帖子列表-视频详情-分享渠道（钉钉）——帖子埋点BO
  ID_10423: 10423, // 资讯-帖子列表-视频详情-分享渠道（好友）——帖子埋点BO
  ID_10424: 10424, // 资讯-帖子列表-视频详情-分享渠道（举报成页的举报）——帖子埋点BO
  ID_10425: 10425, // 资讯-帖子列表-视频详情-分享渠道（屏蔽）——帖子埋点BO
  ID_10426: 10426, // 资讯-帖子详情-视频详情——帖子埋点BO
  ID_10427: 10427, // 资讯-帖子详情-视频详情-点赞——帖子埋点BO
  ID_10428: 10428, // 资讯-帖子详情-视频详情-取消点赞——帖子埋点BO
  ID_10429: 10429, // 资讯-帖子详情-视频详情-评论——帖子埋点BO
  ID_10430: 10430, // 资讯-帖子详情-视频详情-评论输入框——帖子埋点BO
  ID_10431: 10431, // 资讯-帖子详情-视频详情-评论回复——帖子埋点BO
  ID_10432: 10432, // 资讯-帖子详情-视频详情-分享渠道（微信）——帖子埋点BO
  ID_10433: 10433, // 资讯-帖子详情-视频详情-分享渠道（朋友圈）——帖子埋点BO
  ID_10434: 10434, // 资讯-帖子详情-视频详情-分享渠道（qq）——帖子埋点BO
  ID_10435: 10435, // 资讯-帖子详情-视频详情-分享渠道（微博）——帖子埋点BO
  ID_10436: 10436, // 资讯-帖子详情-视频详情-分享渠道（钉钉）——帖子埋点BO
  ID_10437: 10437, // 资讯-帖子详情-视频详情-分享渠道（好友）——帖子埋点BO
  ID_10438: 10438, // 资讯-帖子详情-视频详情-分享渠道（举报成页的举报）——帖子埋点BO
  ID_10439: 10439, // 资讯-帖子详情-视频详情-分享渠道（屏蔽）——帖子埋点BO
  ID_10440: 10440, // 发布动态-上传图片
  ID_10441: 10441, // 发布动态-话题
  ID_10442: 10442, // 发布动态-@
  ID_10443: 10443, // 发布动态-定位
  ID_10444: 10444, // 发布动态-定位-不显示
  ID_10445: 10445, // 发布文章-话题
  ID_10446: 10446, // 发布文章-@
  ID_10447: 10447, // 发布文章-定位
  ID_10448: 10448, // 发布文章-定位-不显示
  ID_10449: 10449, // 发布文章-添加图片
  ID_10450: 10450, // 发布动态-弹窗保存
  ID_10451: 10451, // 发布动态-弹窗不保存
  ID_10452: 10452, // 发布文章-弹窗保存
  ID_10453: 10453, // 发布文章-弹窗不保存
  ID_10479: 10479, // 即刻-帖子列表-视频详情-评论点赞——帖子埋点BO
  ID_10480: 10480, // 即刻-帖子列表-视频详情-评论取消点赞——帖子埋点BO
  ID_10481: 10481, // 热点-帖子详情-视频详情-评论点赞——帖子埋点BO
  ID_10482: 10482, // 热点-帖子详情-视频详情-评论取消点赞——帖子埋点BO
  ID_10483: 10483, // 资讯-帖子列表-视频详情-评论点赞——帖子埋点BO
  ID_10484: 10484, // 资讯-帖子列表-视频详情-评论取消点赞——帖子埋点BO
  ID_10485: 10485, // 热点-帖子列表-视频详情-评论点赞——帖子埋点BO
  ID_10486: 10486, // 热点-帖子列表-视频详情-评论取消点赞——帖子埋点BO
  ID_10487: 10487, // 资讯-帖子详情-视频详情-评论点赞——帖子埋点BO
  ID_10488: 10488, // 资讯-帖子详情-视频详情-评论取消点赞——帖子埋点BO
  ID_20001: 20001, // Banner
  ID_20002: 20002, // 资讯列表页
  ID_20003: 20003, // 活动列表页
  ID_20004: 20004, // 即刻列表页
  ID_20005: 20005, // 热点列表页
  ID_20006: 20006, // 帖子详情页
  ID_20007: 20007, // 车辆详情页
  ID_20008: 20008, // 车辆下单页-确认订单页
  ID_20009: 20009, // 车辆付款页面
  ID_20010: 20010, // 商品列表页
  ID_20011: 20011, // 商品详情页
  ID_20012: 20012, // 商品购物车页面
  ID_20013: 20013, // 商品下单页-确认订单页
  ID_20014: 20014, // 商品付款页面
  ID_20015: 20015, // 极车-人车
  ID_20016: 20016, // 设置车辆-解除绑定
  ID_20017: 20017, // 用车人管理
  ID_20018: 20018, // 极友
  ID_20019: 20019, // 我的
  ID_20020: 20020, // 极车-整车
  ID_20022: 20022, // 后台切前台统一埋点
  ID_20023: 20023, // APP-SDK成功和错误上报
  ID_30001: 30001, // 进入极车页面
  ID_30002: 30002, // 进入极友页面
  ID_30003: 30003, // 进入极客页面
  ID_30004: 30004, // 进入极市页面
  ID_30005: 30005, // 进入我的页面
  ID_30006: 30006, // 用户在线时长
  ID_30007: 30007, // 商品详情页时长
  ID_30008: 30008, // 车辆详情页时长
  ID_30009: 30009, // 资讯列表页时长
  ID_30010: 30010, // 活动列表页时长
  ID_30011: 30011, // 即刻列表页时长
  ID_30012: 30012, // 热点列表页时长
  ID_30013: 30013, // 活动详情页时长
  ID_30014: 30014, // 专题详情页时长
  ID_30015: 30015, // 富文本贴时长
  ID_30016: 30016, // 进入服务模块
  ID_10271: 10271, // 圈子-banner
  ID_10272: 10272, // 圈子-我的圈子
  ID_10273: 10273, // 圈子-我的圈子-查看更多
  ID_10274: 10274, // 圈子-我的圈子-全部圈子
  ID_10275: 10275, // 圈子-全部圈子-更多
  ID_10276: 10276, // 圈子-全部圈子-查看更多
  ID_10277: 10277, // 圈子-全部圈子-加入
  ID_10278: 10278, // 圈子-我的圈子列表-圈子
  ID_10279: 10279, // 圈子-全部圈子列表-圈子
  ID_10280: 10280, // 圈子-全部圈子列表-加入
  ID_10281: 10281, // 圈子-圈友说列表-点赞
  ID_10282: 10282, // 圈子-圈友说列表-取消点赞
  ID_10283: 10283, // 圈子-圈友说列表-分享
  ID_10284: 10284, // 圈子-圈友说列表-评论
  ID_10285: 10285, // 圈子-圈友说列表-自动评论
  ID_10286: 10286, // 圈子-圈友说列表-作者头像
  ID_10287: 10287, // 圈子-圈友说列表-关注
  ID_10288: 10288, // 圈子-圈友说列表-帖子详情点赞
  ID_10289: 10289, // 圈子-圈友说列表-帖子详情-取消点赞
  ID_10290: 10290, // 圈子-圈友说列表-帖子详情评论
  ID_10291: 10291, // 圈子-圈友说列表-帖子详情-评论输入框
  ID_10292: 10292, // 圈子-圈友说列表-帖子详情-作者头像
  ID_10293: 10293, // 圈子-圈友说列表-帖子详情-关注
  ID_10294: 10294, // 圈子-圈友说列表-帖子详情页-分享渠道（微信、朋友圈、qq、微博、钉钉、好友、举报成页的举报、屏蔽、删除）
  ID_10295: 10295, // 圈子-圈友说列表-帖子详情-评论
  ID_10296: 10296, // 圈子-圈友说列表-评论列表-回复
  ID_10297: 10297, // 圈子主页-圈主信息
  ID_10298: 10298, // 圈子主页-圈友信息
  ID_10299: 10299, // 圈子主页-圈友列表-头像
  ID_10300: 10300, // 圈子主页-圈友列表-关注
  ID_10301: 10301, // 圈子主页-圈友列表-回粉
  ID_10302: 10302, // 圈子主页-圈友列表-聊天
  ID_10303: 10303, // 圈子主页-分享
  ID_10304: 10304, // 圈子主页-加入
  ID_10305: 10305, // 圈子主页-加入-发送
  ID_10306: 10306, // 圈子主页-审核
  ID_10307: 10307, // 圈子主页-审核-审核列表-通过
  ID_10308: 10308, // 圈子主页-审核-审核列表-拒绝
  ID_10309: 10309, // 圈子主页-审核-申请列表-头像
  ID_10310: 10310, // 圈子主页-审核-申请详情-查看主页
  ID_10311: 10311, // 圈子主页-审核-申请详情-通过
  ID_10312: 10312, // 圈子主页-审核-申请详情-拒绝
  ID_10313: 10313, // 圈子主页-圈友说列表-点赞
  ID_10314: 10314, // 圈子主页-圈友说列表-取消点赞
  ID_10315: 10315, // 圈子主页-圈友说列表-分享
  ID_10316: 10316, // 圈子主页-圈友说列表-评论
  ID_10317: 10317, // 圈子主页-圈友说列表-自动评论
  ID_10318: 10318, // 圈子主页-圈友说列表-作者头像
  ID_10319: 10319, // 圈子主页-圈友说列表-关注
  ID_10320: 10320, // 圈子主页-圈友说列表-帖子详情点赞
  ID_10321: 10321, // 圈子主页-圈友说列表-帖子详情-取消点赞
  ID_10322: 10322, // 圈子主页-圈友说列表-帖子详情评论
  ID_10323: 10323, // 圈子主页-圈友说列表-帖子详情-评论输入框
  ID_10324: 10324, // 圈子主页-圈友说列表-帖子详情-作者头像
  ID_10325: 10325, // 圈子主页-圈友说列表-帖子详情-关注
  ID_10326: 10326, // 圈子主页-圈友说列表-帖子详情页-分享渠道（微信、朋友圈、qq、微博、钉钉、好友、举报成页的举报、屏蔽、删除）
  ID_10327: 10327, // 圈子主页-圈友说列表-帖子详情-评论
  ID_10328: 10328, // 圈子主页-圈友说列表-评论列表-回复
  ID_10329: 10329, // 圈子主页-我的列表-点赞
  ID_10330: 10330, // 圈子主页-我的列表-取消点赞
  ID_10331: 10331, // 圈子主页-我的列表-分享
  ID_10332: 10332, // 圈子主页-我的列表-评论
  ID_10333: 10333, // 圈子主页-我的列表-自动评论
  ID_10334: 10334, // 圈子主页-我的列表-帖子详情点赞
  ID_10335: 10335, // 圈子主页-我的列表-帖子详情-取消点赞
  ID_10336: 10336, // 圈子主页-我的列表-帖子详情评论
  ID_10337: 10337, // 圈子主页-我的列表-帖子详情-评论输入框
  ID_10338: 10338, // 圈子主页-我的列表-帖子详情页-分享渠道（微信、朋友圈、qq、微博、钉钉、好友、删除）
  ID_10339: 10339, // 圈子主页-我的列表-帖子详情-评论
  ID_10340: 10340, // 圈子主页-我的列表-评论列表-回复
  ID_10341: 10341, // 圈子主页-发帖
  ID_10342: 10342, // 圈子主页-发帖-发布动态
  ID_10343: 10343, // 圈子主页-发帖-发布文章
  ID_10344: 10344, // 圈子主页-发帖-取消
  ID_10345: 10345, // 圈子主页-置顶
  ID_10346: 10346, // 圈子主页-取消置顶
  ID_10347: 10347, // 他人个人主页-圈子
  ID_10348: 10348, // 消息通知-系统通知-开
  ID_10349: 10349, // 消息通知-系统通知-关
  ID_10350: 10350, // 消息通知-车辆消息-开
  ID_10351: 10351, // 消息通知-车辆消息-关
  ID_10352: 10352, // 消息通知-交易消息-开
  ID_10353: 10353, // 消息通知-交易消息-关
  ID_10354: 10354, // 消息通知-互动消息-开
  ID_10355: 10355, // 消息通知-互动消息-关
  ID_20021: 20021, // 圈子列表页
  ID_10454: 10454, // 进入智能中控(电动摩托)
  ID_10455: 10455, // 进入智能中控(电动自行车)
  ID_10456: 10456, // 进入智能中控导航(电动摩托)
  ID_10457: 10457, // 进入智能中控导航(电动自行车)
  ID_30172: 30172, // 智能中控使用时长(电动摩托)
  ID_30173: 30173, // 智能中控使用时长(电动自行车)
  ID_10458: 10458, // Motoplay连接成功
  ID_30174: 30174, // 开始连接Motoplay时长
  ID_30261: 30261, // AI助手-停留时长
  ID_10471: 10471, // 蓝牙连接日志事件
  ID_10472: 10472, // 车辆音量大小调整
  ID_10473: 10473, // 蓝牙后台搜索
  ID_10464: 10464, // 添加用车人
  ID_10465: 10465, // 添加临时用车人
  ID_10466: 10466, // 取消用车人共享
  ID_10467: 10467, // 删除用车人记录
  ID_10468: 10468, // 用车人修改时长与重新开启
  ID_10469: 10469, // 分享用车人
  ID_10475: 10475, // 打开APP开始连接保存
  ID_10476: 10476, // 点击MotoPlay开始连接保存
  ID_10477: 10477, // 远程开机
  ID_10478: 10478, // 远程关机
  ID_10496: 10496, // 车辆设置-感应解锁-升级到感应解锁2.0
  ID_10497: 10497, // 感应解锁2.0
  ID_10498: 10498, // 感应解锁2.0-立即配对
  ID_10499: 10499, // 感应解锁2.0配对弹窗-配对
  ID_10500: 10500, // 感应解锁2.0配对弹窗-取消
  ID_10501: 10501, // 感应解锁2.0配对弹窗-重新配对
  ID_10502: 10502, // 感应解锁2.0-关闭感应解锁2.0
  ID_10503: 10503, // 感应解锁2.0-关闭感应解锁2.0-确定
  ID_10504: 10504, // 感应解锁2.0-关闭感应解锁2.0-取消
  ID_10505: 10505, // 加载页—重新连接
  ID_10506: 10506, // 加载页—连接仪表
  ID_10513: 10513, // 车辆实时风控-查看手机号
  ID_10514: 10514, // 车辆实时风控-查看用户名
  ID_10515: 10515, // 设备列表-查看首次绑定手机号
  ID_10516: 10516, // 设备列表-查看当前绑定手机号
  ID_10517: 10517, // 设备列表-绑定次数-查看手机号
  ID_10518: 10518, // 报警历史记录-查看手机号
  ID_10519: 10519, // 报警实时风控-查看手机号
  ID_10520: 10520, // 故障实时风控-查看手机号
  ID_10521: 10521, // 故障历史记录-查看手机号
  ID_10522: 10522, // APP积分发放-查看手机号
  ID_10523: 10523, // 签到盲盒管理-查看手机号
  ID_10524: 10524, // APP用户管理页面-查看手机号
  ID_10525: 10525, // 反馈管理页面-查看手机号
  ID_10526: 10526, // 积分商城订单管理页面-用户手机号-查看手机号
  ID_10527: 10527, // 积分商城订单管理页面-收货人手机号-查看手机号
  ID_10528: 10528, // 门店管理页面-查看手机号
  ID_10529: 10529, // 充电功率可调
  ID_10530: 10530, // 强制ready
  ID_10531: 10531, // 感应解锁距离设置
  ID_10532: 10532, // 签到-30天签到H5-活动规则
  ID_10533: 10533, // 签到-30天签到H5-查看上月
  ID_10534: 10534, // 签到-30天签到H5-查看下月
  ID_10535: 10535, // 签到-30天签到H5-盲盒奖品
  ID_10536: 10536, // 签到-30天签到H5-盲盒弹窗-马上领取
  ID_10537: 10537, // 签到-30天签到H5-盲盒弹窗-开心收下
  ID_10538: 10538, // 签到-30天签到H5-盲盒弹窗-填写收货地址
  ID_10539: 10539, // 签到-30天签到H5-盲盒弹窗-点击领取-填写收货地址-选择此地址
  ID_10540: 10540, // 签到-30天签到H5-盲盒弹窗-点击领取-填写收货地址-编辑
  ID_10541: 10541, // 签到-30天签到H5-盲盒弹窗-点击领取-填写收货地址-编辑-清空
  ID_10542: 10542, // 签到-30天签到H5-盲盒弹窗-点击领取-填写收货地址-编辑-保存
  ID_10543: 10543, // 签到-30天签到H5-盲盒弹窗-点击领取-填写收货地址-新增地址
  ID_10544: 10544, // 签到-30天签到H5-盲盒弹窗-点击领取-填写收货地址-新增地址-新增到地址簿
  ID_10545: 10545, // 签到-30天签到H5-盲盒弹窗-点击领取-填写收货地址-新增地址-保存
  ID_10546: 10546, // 签到-30天签到H5-盲盒弹窗-点击领取-填写收货地址-新增地址-下次再编辑
  ID_10547: 10547, // 签到-30天签到H5-盲盒弹窗-点击领取-填写收货地址-新增地址-继续编辑
  ID_10548: 10548, // 扫码绑定车辆
  ID_10549: 10549, // 设置-清除缓存
  ID_10550: 10550, // 设置-清除缓存-取消
  ID_10551: 10551, // 设置-清除缓存-确定
  ID_10552: 10552, // 隐私政策
  ID_10553: 10553, // 个人信息收集清单
  ID_10554: 10554, // 个人信息收集清单-返回
  ID_10555: 10555, // 第三方信息共享清单
  ID_10556: 10556, // 第三方信息共享清单-返回
  ID_10557: 10557, // 基本资料-保存
  ID_10558: 10558, // 热点-已关注
  ID_10559: 10559, // 热点-已关注-继续关注
  ID_10560: 10560, // 热点-已关注-取消关注
  ID_10561: 10561, // 即刻-已关注
  ID_10562: 10562, // 即刻-已关注-继续关注
  ID_10563: 10563, // 即刻-已关注-取消关注
  ID_10564: 10564, // 活动-已关注
  ID_10565: 10565, // 活动-已关注-继续关注
  ID_10566: 10566, // 活动-已关注-取消关注
  ID_10567: 10567, // 资讯-已关注
  ID_10568: 10568, // 资讯-已关注-继续关注
  ID_10569: 10569, // 资讯-已关注-取消关注
  ID_10570: 10570, // 热点-作者头像-作者主页头像
  ID_10571: 10571, // 热点-作者头像-作者主页头像-保存到相册
  ID_10572: 10572, // 热点-作者头像-作者主页头像-取消
  ID_10573: 10573, // 即刻-作者头像-作者主页头像
  ID_10574: 10574, // 即刻-作者头像-作者主页头像-保存到相册
  ID_10575: 10575, // 即刻-作者头像-作者主页头像-取消
  ID_10576: 10576, // 活动-作者头像-作者主页头像
  ID_10577: 10577, // 活动-作者头像-作者主页头像-保存到相册
  ID_10578: 10578, // 活动-作者头像-作者主页头像-取消
  ID_10579: 10579, // 资讯-作者头像-作者主页头像
  ID_10580: 10580, // 资讯-作者头像-作者主页头像-保存到相册
  ID_10581: 10581, // 资讯-作者头像-作者主页头像-取消
  ID_10582: 10582, // 发布动态-返回
  ID_10583: 10583, // 发布动态-返回-保存
  ID_10584: 10584, // 发布动态-返回-不保存
  ID_10585: 10585, // 发布文章-返回
  ID_10586: 10586, // 发布文章-返回-保存
  ID_10587: 10587, // 发布文章-返回-不保存
  ID_10588: 10588, // 车辆信息-车架号-复制
  ID_10589: 10589, // 车辆信息-电机号-复制
  ID_10590: 10590, // 社区管理-活动管理-活动列表-活动数据-查看手机号
  ID_10591: 10591, // 商城管理-商城订单管理-商城订单管理页面-详情-查看手机号
  ID_10592: 10592, // 商城管理-商城订单管理-商城订单管理页面-详情-查看地址
  ID_10593: 10593, // 商城管理-商城订单管理-退换货管理页面-详情-查看手机号
  ID_10594: 10594, // 商城管理-整车订单管理-整车订单列表页-详情-查看手机号
  ID_10595: 10595, // 商城管理-整车订单管理-退货管理-详情-查看手机号
  ID_10596: 10596, // 商城管理-积分商城订单管理-积分商城退换货管理-详情-查看手机号
  ID_10597: 10597, // 人机管理-车辆管理-车辆管理页面-查看手机号
  ID_10598: 10598, // 打开密码解锁
  ID_10599: 10599, // 电池绑定
  ID_10600: 10600, // 最高车速限制
  ID_10601: 10601, // 调节车速
  ID_10602: 10602, // 打开边撑感应功能
  ID_10603: 10603, // 打开低电量延长续航功能
  ID_10604: 10604, // 调节车辆音效大小
  ID_10605: 10605, // 动能回收（street模式）
  ID_10606: 10606, // 动能回收（sport模式）
  ID_10607: 10607, // 充电功率可调_AE8
  ID_10608: 10608, // 充电功率可调_AE6
  ID_10609: 10609, // 弹窗-重试
  ID_10610: 10610, // Motoplay 连接失败
  ID_10611: 10611, // 首页-高德license鉴权-高德鉴权失败
  ID_10612: 10612, // 极车_评分弹窗_选择
  ID_10613: 10613, // 极客_评分弹窗_选择
  ID_10614: 10614, // 我的-评分弹窗-选择
  ID_10615: 10615, // eTCS功能开关点击
  ID_10616: 10616, // 勾选隐私政策并登录
  ID_10617: 10617, // 同意隐私并一键登录
  ID_10618: 10618, // 勾选隐私并选择微博登录
  ID_10619: 10619, // 勾选隐私并选择微信登录
  ID_10620: 10620, // 勾选隐私并选择QQ登录
  ID_10621: 10621, // 微信登录-同意并继续
  ID_10622: 10622, // QQ登录-同意并继续
  ID_10623: 10623, // 微博登录-同意并继续
  ID_10624: 10624, // 小程序勾选隐私政策并登录
  ID_10625: 10625, // 小程序同意隐私政策并继续登录
  ID_10626: 10626, // 小组件-点击开关锁
  ID_10627: 10627, // 小组件-点击闪灯鸣笛
  ID_10628: 10628, // 其他方式勾选隐私政策并登录
  ID_10629: 10629, // 其他方式同意隐私并一键登录
  ID_10630: 10630, // 查看反馈手机号
  ID_10631: 10631, // 查看反馈用户手机号
  ID_10632: 10632, // Motoplay连接断开
  ID_10633: 10633, // 限速-运动模式
  ID_10634: 10634, // 限速-经济模式
  ID_10635: 10635, // 限速-街道模式
  ID_10636: 10636, // 小组件-添加
  ID_10637: 10637, // 小组件-删除
  ID_10638: 10638, // 通过小组件进入app
  ID_10639: 10639, // Siri 开机
  ID_10640: 10640, // Siri 关机
  ID_10641: 10641, // Siri 车辆鸣笛
  ID_10642: 10642, // Siri 车辆状态
  ID_10643: 10643, // Siri 车辆定位
  ID_10644: 10644, // Siri 充电状态
  ID_10645: 10645, // Siri 剩余电量
  ID_10646: 10646, // 打开座垫
  ID_10647: 10647, // 打开储物箱
  ID_10648: 10648, // 开关定速巡航保持
  ID_10649: 10649, // 开关ABS开关
  ID_10650: 10650, // 进行仪表设置
  ID_10651: 10651, // 开关电自座垫感应
  ID_10652: 10652, // 同意自定义音效添加服务协议
  ID_10653: 10653, // 点击进入自定义音效
  ID_10654: 10654, // 完成命名后点击保存
  ID_10655: 10655, // 完成命名后点击保存
  ID_10656: 10656, // 点击“立即添加”按钮发起写卡
  ID_10657: 10657, // 手表-点击开锁
  ID_10658: 10658, // 手表-点击关锁
  ID_10659: 10659, // 手表-点击寻车
  ID_10660: 10660, // 手表-点击定位
  ID_10666: 10666, // 仪表写卡失败
  ID_10664: 10664, // 充电功率可调（TBOX）-设置成功
  ID_10661: 10661, // 紧急制动爆闪
  ID_10662: 10662, // 超时自动关机
  ID_10663: 10663, // 高声寻车
  ID_10665: 10665, // 陡坡缓降
  ID_10667: 10667, // 开启ACC自适应巡航成功
  ID_10668: 10668, // 开启ACC自适应巡航失败
  ID_10669: 10669, // 投影灯开关
  ID_10670: 10670, // 自动龙头锁开关
  ID_10735: 10735, // 开机自定义音效设置成功
  ID_10736: 10736, // 关机自定义音效设置成功
  ID_10737: 10737, // 震动报警自定义音效设置成功
  ID_10738: 10738, // Hello自定义音效设置成功
  ID_10739: 10739, // 年度报告分享-微信好友
  ID_10740: 10740, // 年度报告分享-朋友圈
  ID_10741: 10741, // 年度报告分享-QQ好友
  ID_10742: 10742, // 年度报告分享-微博
  ID_10743: 10743, // 年度报告分享-钉钉
  ID_10744: 10744, // 年度报告分享-摩范圈
  ID_10745: 10745, // 年度报告分享-复制链接
  ID_10746: 10746, // 查看年度报告
  ID_10747: 10747, // 同意协议
  ID_30260: 30260, // 页面停留时长
  ID_10748: 10748, // 首页OTA入口点击
  ID_10749: 10749, // 首页OTA入口关闭
  ID_10750: 10750, // 点击关闭此次提示
  ID_10751: 10751, // 点击此版本不再提示
  ID_10752: 10752, // 三包政策
  ID_10753: 10753, // 配件价格
  ID_10754: 10754, // 服务-顶部客服
  ID_10755: 10755, // 服务-顶部在线客服
  ID_10756: 10756, // 服务-顶部电话客服
  ID_10757: 10757, // 服务-400电话拨打
  ID_10758: 10758, // 服务-中间在线客服
  ID_10759: 10759, // 去评价
  ID_10760: 10760, // 发布评价
  ID_10761: 10761, // 开屏广告
  ID_10762: 10762, // AI助手-用户点击首页悬浮入口
  ID_10763: 10763, // AI助手-开始对话
  ID_10764: 10764, // AI助手-角色切换
  ID_10765: 10765, // AI助手-推荐问题
  ID_10766: 10766, // AI助手-联网搜索
  ID_10767: 10767, // AI助手-问题反馈
  ID_10768: 10768, // AI助手-对话信息
  ID_10769: 10769, // AI助手-拦截敏感内容
  ID_10770: 10770, // 我的-查看详情-违规详情-社区规范
  ID_10771: 10771, // 我的-查看详情-违规详情-我要申诉
  ID_10772: 10772, // 我的-查看详情-违规详情-申诉详情
  ID_10773: 10773, // 自己个人主页-查看详情-违规详情-社区规范
  ID_10774: 10774, // 自己个人主页-查看详情-违规详情-我要申诉
  ID_10775: 10775, // 自己个人主页-查看详情-违规详情-申诉详情
  ID_10776: 10776, // 消息通知-系统消息-违规详情-社区规范
  ID_10777: 10777, // 消息通知-系统消息-违规详情-我要申诉
  ID_10778: 10778, // 消息通知-系统消息-违规详情-申诉详情
  ID_20234: 20234, // 仪表导航-APP首页-曝光
  ID_10833: 10833, // 仪表导航-APP首页-点击
  ID_20235: 20235, // 仪表导航-APP仪表导航首页-曝光
  ID_10834: 10834, // 仪表导航-搜索框-点击
  ID_10835: 10835, // 仪表导航-搜索框-搜索按钮-点击
  ID_20236: 20236, // 仪表导航-导航规划页-曝光
  ID_10836: 10836, // 仪表导航-导航规划页-投屏导航按钮-点击
  ID_10795: 10795, // ACC开关状态变更
  ID_10796: 10796, // 说明协议确认
  ID_20237: 20237, // 双电动力模式-弹窗-曝光
  ID_10851: 10851, // 双电动力模式-弹窗-关闭
  ID_10852: 10852, // 双电动力模式-弹窗-立即开启
  ID_20238: 20238, // 双电动力模式-车辆设置列表页-曝光
  ID_10853: 10853, // 双电动力模式-车辆设置列表页-点击
  ID_10854: 10854, // 双电动力模式-车辆设置详情页-切换按钮点击
  ID_10800: 10800, // 即刻-最新
  ID_10801: 10801, // 即刻-关注
  ID_10855: 10855, // 即刻-默认
  ID_10802: 10802, // 资讯-专栏
  ID_10803: 10803, // 资讯-专栏-类目
  ID_10804: 10804, // 资讯-专栏-类目-列表帖子
  ID_10805: 10805, // 资讯-专栏-类目-列表帖子-点赞
  ID_10806: 10806, // 资讯-专栏-类目-列表帖子-取消点赞
  ID_10807: 10807, // 资讯-专栏-类目-列表帖子-帖子详情-评论
  ID_10808: 10808, // 资讯-专栏-类目-列表帖子-帖子详情-分享渠道
  ID_10809: 10809, // 资讯-专栏-列表帖子
  ID_10810: 10810, // 资讯-专栏-列表帖子-帖子详情-点赞
  ID_10811: 10811, // 资讯-专栏-列表帖子-帖子详情-取消点赞
  ID_10812: 10812, // 资讯-专栏-列表帖子-帖子详情-评论
  ID_10813: 10813, // 资讯-专栏-列表帖子-帖子详情-分享渠道
  ID_10814: 10814, // 资讯-美图-美图详情
  ID_10815: 10815, // 资讯-美图-更多
  ID_10816: 10816, // 资讯-美图-更多-美图模块
  ID_10817: 10817, // 资讯-美图-更多-美图模块-子模块
  ID_10818: 10818, // 热点-帖子-详情页-分享渠道
  ID_10819: 10819, // 热点-帖子列表-视频详情-分享渠道
  ID_10820: 10820, // 热点-帖子详情-视频详情-分享渠道
  ID_10821: 10821, // 活动帖-详情页-分享
  ID_10822: 10822, // 即刻-帖子列表-视频详情-分享渠道
  ID_10823: 10823, // 即刻-帖子详情-视频详情-分享渠道
  ID_10824: 10824, // 即刻-帖子-详情页-分享渠道
  ID_10825: 10825, // 补签卡
  ID_10826: 10826, // 补签卡-立即补签
  ID_10827: 10827, // 补签卡-补签提示弹窗-立即兑换
  ID_10828: 10828, // 补签卡-补签提示弹窗-立即兑换-立即兑换
  ID_10829: 10829, // 补签卡-补签提示弹窗-立即兑换-立即兑换-确认兑换
  ID_10830: 10830, // 补签卡-补签提示弹窗-立即兑换-立即兑换-确认兑换-查看补签卡
  ID_10831: 10831, // 补签卡-补签提示弹窗-立即兑换-立即兑换-确认兑换-查看补签卡-立即使用
  ID_10832: 10832, // 补签卡-立即兑换
  ID_20230: 20230, // 资讯-专栏页
  ID_20231: 20231, // 资讯-类目详情页
  ID_20232: 20232, // 资讯-美图列表
  ID_20233: 20233, // 资讯-美图列表-美图详情
  ID_30262: 30262, // 资讯-专栏页时长
  ID_30263: 30263, // 资讯-专栏-类目详情页时长
  ID_30264: 30264, // 资讯-美图列表时长
  ID_30265: 30265, // 资讯-美图列表-美图详情时长
  ID_10900: 10900, // 活动-活动进行中-全部活动
  ID_10901: 10901, // 活动-活动进行中-线上活动
  ID_10902: 10902, // 活动-活动进行中-线下活动
  ID_10903: 10903, // 活动-活动进行中-帖子
  ID_10904: 10904, // 活动-活动进行中-帖子-帖子详情-分享渠道
  ID_10905: 10905, // 活动-活动进行中-帖子-活动详情-我要参加
  ID_10906: 10906, // 活动-活动进行中-帖子-活动详情-外部发帖信息上传
  ID_10907: 10907, // 活动-活动进行中-帖子-活动详情-我要发帖
  ID_10908: 10908, // 活动-活动进行中-帖子-活动详情-外部发帖信息修改
  ID_10909: 10909, // 活动-活动进行中-帖子-活动详情-再发一条
  ID_10910: 10910, // 活动-活动进行中-帖子-活动详情-外部发帖信息修改-表单提交
  ID_10911: 10911, // 活动-活动进行中-帖子-活动详情-我要发帖-继续发布
  ID_10912: 10912, // 活动-活动进行中-帖子-活动详情-我要发帖-重新编辑
  ID_10913: 10913, // 活动-活动进行中-帖子-活动详情-再发一条-继续发布
  ID_10914: 10914, // 活动-活动进行中-帖子-活动详情-再发一条-重新编辑
  ID_10915: 10915, // 活动-活动进行中-帖子-活动详情-已参加-我要发帖
  ID_10916: 10916, // 活动-中奖公告-帖子
  ID_10917: 10917, // 活动-中奖公告-帖子-帖子详情-分享渠道
  ID_10918: 10918, // 活动-中奖公告-全部-帖子
  ID_10919: 10919, // 活动-中奖公告-全部-帖子-帖子详情-分享渠道
  ID_10920: 10920, // 活动-中奖公告-帖子-帖子详情-查询中奖
  ID_10921: 10921, // 活动-中奖公告-帖子-帖子详情-查询中奖-积分中奖弹窗-立即查看
  ID_10922: 10922, // 活动-中奖公告-帖子-帖子详情-查询中奖-实物中奖弹窗-立即查看
  ID_10923: 10923, // 活动-中奖公告-帖子-帖子详清-查询中奖-实物中奖弹窗-填写收货信息
  ID_10924: 10924, // 活动-中奖公告-帖子-帖子详清-查询中奖-实物中奖弹窗-确认收货信息
  ID_10926: 10926, // 活动-历史活动-帖子
  ID_10927: 10927, // 活动-历史活动-帖子-帖子详清-分享渠道
  ID_10928: 10928, // 活动-历史活动-帖子-活动详情-已结束-我要发帖
  ID_10929: 10929, // 活动-历史活动-帖子-活动详青-已结束-查看热门帖子
  ID_10930: 10930, // 热点-帖子列表-话题
  ID_10931: 10931, // 即刻-帖子列表-话题
  ID_10932: 10932, // 热点-帖子列表-帖子详情-话题
  ID_10933: 10933, // 即刻-帖子列表-帖子详情-话题
  ID_10934: 10934, // 资讯-专栏-列表帖子-帖子详情-话题
  ID_10935: 10935, // 资讯-专栏-类目-列表帖子-帖子详情-话题
  ID_10936: 10936, // 热点-帖子详情-推荐查看
  ID_10937: 10937, // 即刻-帖子详情-推荐查看
  ID_10938: 10938, // 资讯-帖子详情-推荐查看
  ID_10939: 10939, // 他人个人主页-发帖列表-帖子详情-推荐查看
  ID_10940: 10940, // 我的-我的活动
  ID_10941: 10941, // 我的-我的活动-已参加的活动-发现更多活动
  ID_10942: 10942, // 我的-我的活动-中奖奖品-发现更多活动
  ID_10943: 10943, // 我的-我的活动-中奖奖品-填写收货信息
  ID_10944: 10944, // 我的-我的活动-中奖奖品-确认收货信息
  ID_10945: 10945, // 新手视频指导-车型
  ID_11100: 11100, // 即刻-帖子列表-分享-分享-微信
  ID_11101: 11101, // 即刻-帖子列表-分享-分享-朋友圈
  ID_11102: 11102, // 即刻-帖子列表-分享-分享-qq
  ID_11103: 11103, // 即刻-帖子列表-分享-分享-微博
  ID_11104: 11104, // 即刻-帖子列表-分享-分享-钉钉
  ID_11105: 11105, // 即刻-帖子列表-分享-分享-好友
  ID_11106: 11106, // 即刻-帖子列表-分享-分享-举报页
  ID_11107: 11107, // 即刻-帖子列表-分享-分享-屏蔽
  ID_11108: 11108, // 即刻-帖子列表-分享-分享-复制链接
  ID_11109: 11109, // 即刻-帖子列表-视频详情-分享
  ID_11110: 11110, // 即刻-帖子详情-视频详情-分享
  ID_11111: 11111, // 即刻-帖子_详情页-分享
  ID_11112: 11112, // 热点-banner-帖子详情-分享-微信
  ID_11113: 11113, // 热点-banner-帖子详情-分享-朋友圈
  ID_11114: 11114, // 热点-banner-帖子详情-分享-qq
  ID_11115: 11115, // 热点-banner-帖子详情-分享-微博
  ID_11116: 11116, // 热点-banner-帖子详情-分享-钉钉
  ID_11117: 11117, // 热点-banner-帖子详情-分享-好友
  ID_11118: 11118, // 热点-banner-帖子详情-分享-举报页
  ID_11119: 11119, // 热点-banner-帖子详情-分享-屏蔽
  ID_11120: 11120, // 热点-banner-帖子详情-分享-复制链接
  ID_11121: 11121, // 热点-banner-帖子详情-分享
  ID_11122: 11122, // 热点-banner-帖子详情-视频详情-分享
  ID_11123: 11123, // 热点-banner-帖子详情-视频详情-分享-微信
  ID_11124: 11124, // 热点-banner-帖子详情-视频详情-分享-朋友圈
  ID_11125: 11125, // 热点-banner-帖子详情-视频详情-分享-qq
  ID_11126: 11126, // 热点-banner-帖子详情-视频详情-分享-微博
  ID_11127: 11127, // 热点-banner-帖子详情-视频详情-分享-钉钉
  ID_11128: 11128, // 热点-banner-帖子详情-视频详情-分享-好友
  ID_11129: 11129, // 热点-banner-帖子详情-视频详情-分享-举报页
  ID_11130: 11130, // 热点-banner-帖子详情-视频详情-分享-屏蔽
  ID_11131: 11131, // 热点-banner-帖子详情-视频详情-分享-复制链接
  ID_11132: 11132, // 热点-帖子列表-分享
  ID_11133: 11133, // 热点-帖子列表-分享-微信
  ID_11134: 11134, // 热点-帖子列表-分享-朋友圈
  ID_11135: 11135, // 热点-帖子列表-分享-qq
  ID_11136: 11136, // 热点-帖子列表-分享-微博
  ID_11137: 11137, // 热点-帖子列表-分享-钉钉
  ID_11138: 11138, // 热点-帖子列表-分享-好友
  ID_11139: 11139, // 热点-帖子列表-分享-举报页
  ID_11140: 11140, // 热点-帖子列表-分享-屏蔽
  ID_11141: 11141, // 热点-帖子列表-分享-复制链接
  ID_11142: 11142, // 活动-帖子列表-分享-分享-微信
  ID_11143: 11143, // 活动-帖子列表-分享-分享-朋友圈
  ID_11144: 11144, // 活动-帖子列表-分享-分享-qq
  ID_11145: 11145, // 活动-帖子列表-分享-分享-微博
  ID_11146: 11146, // 活动-帖子列表-分享-分享-钉钉
  ID_11147: 11147, // 活动-帖子列表-分享-分享-好友
  ID_11148: 11148, // 活动-帖子列表-分享-分享-举报页
  ID_11149: 11149, // 活动-帖子列表-分享-分享-屏蔽
  ID_11150: 11150, // 活动-帖子列表-分享-分享-复制链接
  ID_11151: 11151, // 资讯-专栏-类目-列表帖子-帖子详情-视频详情-点赞
  ID_11152: 11152, // 资讯-专栏-类目-列表帖子-帖子详情-视频详情-取消点赞
  ID_11153: 11153, // 资讯-专栏-类目-列表帖子-帖子详情-视频详情-评论
  ID_11154: 11154, // 资讯-专栏-类目-列表帖子-帖子详情-视频详情-分享
  ID_11155: 11155, // 资讯-专栏-类目-列表帖子-帖子详情-视频详情-分享-微信
  ID_11156: 11156, // 资讯-专栏-类目-列表帖子-帖子详情-视频详情-分享-朋友圈
  ID_11157: 11157, // 资讯-专栏-类目-列表帖子-帖子详情-视频详情-分享-qq
  ID_11158: 11158, // 资讯-专栏-类目-列表帖子-帖子详情-视频详情-分享-微博
  ID_11159: 11159, // 资讯-专栏-类目-列表帖子-帖子详情-视频详情-分享-钉钉
  ID_11160: 11160, // 资讯-专栏-类目-列表帖子-帖子详情-视频详情-分享-好友
  ID_11161: 11161, // 资讯-专栏-类目-列表帖子-帖子详情-视频详情-分享-举报页
  ID_11162: 11162, // 资讯-专栏-类目-列表帖子-帖子详情-视频详情-分享-屏蔽
  ID_11163: 11163, // 资讯-专栏-类目-列表帖子-帖子详情-视频详情-分享-复制链接
  ID_11164: 11164, // 资讯-专栏-列表帖子-帖子详情-视频详情-点赞
  ID_11165: 11165, // 资讯-专栏-列表帖子-帖子详情-视频详情-取消点赞
  ID_11166: 11166, // 资讯-专栏-列表帖子-帖子详情-视频详情-评论
  ID_11167: 11167, // 资讯-专栏-列表帖子-帖子详情-视频详情-分享
  ID_11168: 11168, // 资讯-专栏-列表帖子_帖子详情-视频详情-分享-微信
  ID_11169: 11169, // 资讯-专栏-列表帖子_帖子详情-视频详情-分享-朋友圈
  ID_11170: 11170, // 资讯-专栏-列表帖子_帖子详情-视频详情-分享-qq
  ID_11171: 11171, // 资讯-专栏-列表帖子_帖子详情-视频详情-分享-微博
  ID_11172: 11172, // 资讯-专栏-列表帖子_帖子详情-视频详情-分享-钉钉
  ID_11173: 11173, // 资讯-专栏-列表帖子_帖子详情-视频详情-分享-好友
  ID_11174: 11174, // 资讯-专栏-列表帖子_帖子详情-视频详情-分享-举报页
  ID_11175: 11175, // 资讯-专栏-列表帖子_帖子详情-视频详情-分享-屏蔽
  ID_11176: 11176, // 资讯-专栏-列表帖子_帖子详情-视频详情-分享-复制链接
  ID_11177: 11177, // 搜索-帖子列表-点赞
  ID_11178: 11178, // 搜索-帖子列表-取消点赞
  ID_11179: 11179, // 搜索-帖子列表-评论
  ID_11180: 11180, // 搜索-帖子列表-分享
  ID_11181: 11181, // 搜索-帖子列表-分享-微信
  ID_11182: 11182, // 搜索-帖子列表-分享-朋友圈
  ID_11183: 11183, // 搜索-帖子列表-分享-qq
  ID_11184: 11184, // 搜索-帖子列表-分享-微博
  ID_11185: 11185, // 搜索-帖子列表-分享-钉钉
  ID_11186: 11186, // 搜索-帖子列表-分享-好友
  ID_11187: 11187, // 搜索-帖子列表-分享-举报页
  ID_11188: 11188, // 搜索-帖子列表-分享-屏蔽
  ID_11189: 11189, // 搜索-帖子列表-分享-复制链接
  ID_11190: 11190, // 搜索-帖子列表-视频详情-点赞
  ID_11191: 11191, // 搜索-帖子列表-视频详情-取消点赞
  ID_11192: 11192, // 搜索-帖子列表-视频详情-评论
  ID_11193: 11193, // 搜索-帖子列表-视频详情-分享
  ID_11194: 11194, // 搜索-帖子列表-视频详情-分享-微信
  ID_11195: 11195, // 搜索-帖子列表-视频详情-分享-朋友圈
  ID_11196: 11196, // 搜索-帖子列表-视频详情-分享-qq
  ID_11197: 11197, // 搜索-帖子列表-视频详情-分享-微博
  ID_11198: 11198, // 搜索-帖子列表-视频详情-分享-钉钉
  ID_11199: 11199, // 搜索-帖子列表-视频详情-分享-好友
  ID_11200: 11200, // 搜索-帖子列表-视频详情-分享-举报页
  ID_11201: 11201, // 搜索-帖子列表-视频详情-分享-屏蔽
  ID_11202: 11202, // 搜索-帖子列表-视频详情-分享-复制链接
  ID_11203: 11203, // 搜索-帖子详情-点赞
  ID_11204: 11204, // 搜索-帖子详情-取消点赞
  ID_11205: 11205, // 搜索-帖子详情-评论
  ID_11206: 11206, // 搜索-帖子详情-评论输入框
  ID_11207: 11207, // 搜索-帖子详情-分享
  ID_11208: 11208, // 搜索-帖子详情-分享-微信
  ID_11209: 11209, // 搜索-帖子详情-分享-朋友圈
  ID_11210: 11210, // 搜索-帖子详情-分享-qq
  ID_11211: 11211, // 搜索-帖子详情-分享-微博
  ID_11212: 11212, // 搜索-帖子详情-分享-钉钉
  ID_11213: 11213, // 搜索-帖子详情-分享-好友
  ID_11214: 11214, // 搜索-帖子详情-分享-举报页
  ID_11215: 11215, // 搜索-帖子详情-分享-屏蔽
  ID_11216: 11216, // 搜索-帖子详情-分享-复制链接
  ID_11217: 11217, // 搜索-帖子详情-视频详情-点赞
  ID_11218: 11218, // 搜索-帖子详情-视频详情-取消点赞
  ID_11219: 11219, // 搜索-帖子详情-视频详情-评
  ID_11220: 11220, // 搜索-帖子详情-视频详情-分莫
  ID_11221: 11221, // 搜索-帖子详情-视频详情-分享-微信
  ID_11222: 11222, // 搜索-帖子详情-视频详情-分享-朋友圈
  ID_11223: 11223, // 搜索-帖子详情-视频详情-分享-qq
  ID_11224: 11224, // 搜索-帖子详情-视频详情-分享-微博
  ID_11225: 11225, // 搜索-帖子详情-视频详情-分享-钉钉
  ID_11226: 11226, // 搜索-帖子详情-视频详情-分享-好友
  ID_11227: 11227, // 搜索-帖子详情-视频详情-分享-举报页
  ID_11228: 11228, // 搜索-帖子详情-视频详情-分享-屏蔽
  ID_11229: 11229, // 搜索-帖子详情-视频详情-分享-复制链接
  ID_11230: 11230, // 话题-帖子列表-点赞
  ID_11231: 11231, // 话题-帖子列表-取消点赞
  ID_11232: 11232, // 话题-帖子列表-评论
  ID_11233: 11233, // 话题-帖子列表-分享
  ID_11234: 11234, // 话题-帖子列表-分享-微信
  ID_11235: 11235, // 话题-帖子列表-分享-朋友圈
  ID_11236: 11236, // 话题-帖子列表-分享-qq
  ID_11237: 11237, // 话题-帖子列表-分享-微博
  ID_11238: 11238, // 话题-帖子列表-分享-钉钉
  ID_11239: 11239, // 话题-帖子列表-分享-好友
  ID_11240: 11240, // 话题-帖子列表-分享-举报页
  ID_11241: 11241, // 话题-帖子列表-分享-屏蔽
  ID_11242: 11242, // 话题-帖子列表-分享-复制链接
  ID_11243: 11243, // 话题-帖子列表-视频详情-点舒
  ID_11244: 11244, // 话题-帖子列表-视频详情-取消点赞
  ID_11245: 11245, // 话题-帖子列表-视频详情-评论
  ID_11246: 11246, // 话题-帖子列表-视频详情-分享
  ID_11247: 11247, // 话题-帖子列表-视频详情-分享-微信
  ID_11248: 11248, // 话题-帖子列表-视频详情-分享-朋友圈
  ID_11249: 11249, // 话题-帖子列表-视频详情-分享-qq
  ID_11250: 11250, // 话题-帖子列表-视频详情-分享-微博
  ID_11251: 11251, // 话题-帖子列表-视频详情-分享-钉钉
  ID_11252: 11252, // 话题-帖子列表-视频详情-分享-好友
  ID_11253: 11253, // 话题-帖子列表-视频详情-分享-举报页
  ID_11254: 11254, // 话题-帖子列表-视频详情-分享-屏蔽
  ID_11255: 11255, // 话题-帖子列表-视频详情-分享-复制链接
  ID_11256: 11256, // 话题-帖子详情-点赞
  ID_11257: 11257, // 话题-帖子详情-取消点赞
  ID_11258: 11258, // 话题-帖子详情-评论
  ID_11259: 11259, // 话题-帖子详情-评论输入框
  ID_11260: 11260, // 话题-帖子详情-分享
  ID_11261: 11261, // 话题-帖子详情-分享-微信
  ID_11262: 11262, // 话题-帖子详情-分享-朋友圈
  ID_11263: 11263, // 话题-帖子详情-分享-qq
  ID_11264: 11264, // 话题-帖子详情-分享-微博
  ID_11265: 11265, // 话题-帖子详情-分享-钉钉
  ID_11266: 11266, // 话题-帖子详情-分享-好友
  ID_11267: 11267, // 话题-帖子详情-分享-举报页
  ID_11268: 11268, // 话题-帖子详情-分享-屏蔽
  ID_11269: 11269, // 话题-帖子详情-分享-复制链接
  ID_11270: 11270, // 话题-帖子详情-视频详情-点赞
  ID_11271: 11271, // 话题-帖子详情-视频详情-取消点赞
  ID_11272: 11272, // 话题-帖子详情-视频详情-评论
  ID_11273: 11273, // 话题-帖子详情-视频详情-分享
  ID_11274: 11274, // 话题-帖子详情-视频详情-分享-微信
  ID_11275: 11275, // 话题-帖子详情-视频详情-分享-朋友圈
  ID_11276: 11276, // 话题-帖子详情-视频详情-分享-qq
  ID_11277: 11277, // 话题-帖子详情-视频详情-分享-微博
  ID_11278: 11278, // 话题-帖子详情-视频详情-分享-钉钉
  ID_11279: 11279, // 话题-帖子详情-视频详情-分享-好友
  ID_11280: 11280, // 话题-帖子详情-视频详情-分享-举报页
  ID_11281: 11281, // 话题-帖子详情-视频详情-分享-屏蔽
  ID_11282: 11282, // 话题-帖子详情-视频详情-分享-复制链接
  ID_11283: 11283, // 他人个人主页-发帖列表-话题
  ID_11284: 11284, // 他人个人主页-发帖列表-帖子详情-话题
  ID_11285: 11285, // 他人个人主页-发帖列表-分享-微信
  ID_11286: 11286, // 他人个人主页-发帖列表-分享-朋友圈
  ID_11287: 11287, // 他人个人主页-发帖列表-分享-qq
  ID_11288: 11288, // 他人个人主页-发帖列表-分享-微博
  ID_11289: 11289, // 他人个人主页-发帖列表-分享-钉钉
  ID_11290: 11290, // 他人个人主页-发帖列表-分享-好友
  ID_11291: 11291, // 他人个人主页-发帖列表-分享-举报页
  ID_11292: 11292, // 他人个人主页-发帖列表-分享-屏蔽
  ID_11293: 11293, // 他人个人主页-发帖列表-分享-复制链接
  ID_11294: 11294, // 他人个人主页-发帖列表-视频详情-点赞
  ID_11295: 11295, // 他人个人主页-发帖列表-视频详情-取消点赞
  ID_11296: 11296, // 他人个人主页-发帖列表-视频详情-评论
  ID_11297: 11297, // 他人个人主页-发帖列表-视频详情-分享
  ID_11298: 11298, // 他人个人主页-发帖列表-视频详情-分享-微信
  ID_11299: 11299, // 他人个人主页-发帖列表-视频详情-分享-朋友圈
  ID_11300: 11300, // 他人个人主页-发帖列表-视频详情-分享-qq
  ID_11301: 11301, // 他人个人主页-发帖列表-视频详情-分享-微博
  ID_11302: 11302, // 他人个人主页-发帖列表-视频详情-分享-钉钉
  ID_11303: 11303, // 他人个人主页-发帖列表-视频详情-分享-好友
  ID_11304: 11304, // 他人个人主页-发帖列表-视频详情-分享-举报页
  ID_11305: 11305, // 他人个人主页-发帖列表-视频详情-分享-屏蔽
  ID_11306: 11306, // 他人个人主页-发帖列表-视频详情-分享-复制链接
  ID_11307: 11307, // 他人个人主页-发帖-帖子详情-视频详情-点赞
  ID_11308: 11308, // 他人个人主页-发帖-帖子详情-视频详情-取消点赞
  ID_11309: 11309, // 他人个人主页-发帖-帖子详情-视频详情-评论
  ID_11310: 11310, // 他人个人主页-发帖-帖子详情-视频详情-分享
  ID_11311: 11311, // 他人个人主页-发帖-帖子详情-视频详情-分享-微信
  ID_11312: 11312, // 他人个人主页-发帖-帖子详情-视频详情-分享-朋友圈
  ID_11313: 11313, // 他人个人主页-发帖-帖子详情-视频详情-分享-qq
  ID_11314: 11314, // 他人个人主页-发帖-帖子详情-视频详情-分享-微博
  ID_11315: 11315, // 他人个人主页-发帖-帖子详情-视频详情-分享-钉钉
  ID_11316: 11316, // 他人个人主页-发帖-帖子详情-视频详情-分享-好友
  ID_11317: 11317, // 他人个人主页-发帖-帖子详情-视频详情-分享-举报页
  ID_11318: 11318, // 他人个人主页-发帖-帖子详情-视频详情-分享-屏蔽
  ID_11319: 11319, // 他人个人主页-发帖-帖子详情-视频详情-分享-复制链接
  ID_11320: 11320, // 我的主页-发帖列表-分享
  ID_11321: 11321, // 我的主页-发帖列表-分享-微信
  ID_11322: 11322, // 我的主页-发帖列表-分享-朋友圈
  ID_11323: 11323, // 我的主页-发帖列表-分享-qq
  ID_11324: 11324, // 我的主页-发帖列表-分享-微博
  ID_11325: 11325, // 我的主页-发帖列表-分享-钉钉
  ID_11326: 11326, // 我的主页-发帖列表-分享-好友
  ID_11327: 11327, // 我的主页-发帖列表-分享-举报页
  ID_11328: 11328, // 我的主页-发帖列表-分享-屏蔽
  ID_11329: 11329, // 我的主页-发帖列表-分享-复制链接
  ID_11330: 11330, // 我的主页-发帖列表-视频详情-点赞
  ID_11331: 11331, // 我的主页-发帖列表-视频详情-取消点赞
  ID_11332: 11332, // 我的主页-帖子列表-视频详情-评论
  ID_11333: 11333, // 我的主页-帖子列表-视频详情-分享
  ID_11334: 11334, // 我的主页-帖子列表-视频详情-分享-微信
  ID_11335: 11335, // 我的主页-帖子列表-视频详情-分享-朋友圈
  ID_11336: 11336, // 我的主页-帖子列表-视频详情-分享-qq
  ID_11337: 11337, // 我的主页-帖子列表-视频详情-分享-微博
  ID_11338: 11338, // 我的主页-帖子列表-视频详情-分享-钉钉
  ID_11339: 11339, // 我的主页-帖子列表-视频详情-分享-好友
  ID_11340: 11340, // 我的主页-帖子列表-视频详情-分享-举报页
  ID_11341: 11341, // 我的主页-帖子列表-视频详情-分享-屏蔽
  ID_11342: 11342, // 我的主页-帖子列表-视频详情-分享-复制链接
  ID_11343: 11343, // 我的主页-帖子详情-分享
  ID_11344: 11344, // 我的主页-帖子详情-分享-微信
  ID_11345: 11345, // 我的主页-帖子详情-分享-朋友圈
  ID_11346: 11346, // 我的主页-帖子详情-分享-qq
  ID_11347: 11347, // 我的主页-帖子详情-分享-微博
  ID_11348: 11348, // 我的主页-帖子详情-分享-钉钉
  ID_11349: 11349, // 我的主页-帖子详情-分享-好友
  ID_11350: 11350, // 我的主页-帖子详情-分享-举报页
  ID_11351: 11351, // 我的主页-帖子详情-分享-屏蔽
  ID_11352: 11352, // 我的主页-帖子详情-分享-复制链接
  ID_11353: 11353, // 我的主页-帖子详情-视频详情-点赞
  ID_11354: 11354, // 我的主页-帖子详情-视频详情-取消点赞
  ID_11355: 11355, // 我的主页-帖子详情-视频详情-评论
  ID_11356: 11356, // 我的主页-帖子详情-视频详情-分享
  ID_11357: 11357, // 我的主页-帖子详情-视频详情-分享-微信
  ID_11358: 11358, // 我的主页-帖子详情-视频详情-分享-朋友圈
  ID_11359: 11359, // 我的主页-帖子详情-视频详情-分享-qq
  ID_11360: 11360, // 我的主页-帖子详情-视频详情-分享-微博
  ID_11361: 11361, // 我的主页-帖子详情-视频详情-分享-钉钉
  ID_11362: 11362, // 我的主页-帖子详情-视频详情-分享-好友
  ID_11363: 11363, // 我的主页-帖子详情-视频详情-分享-举报页
  ID_11364: 11364, // 我的主页-帖子详情-视频详情-分享-屏蔽
  ID_11365: 11365, // 我的主页-帖子详情-视频详情-分享-复制链接
  ID_11366: 11366, // 我的主页-发帖列表-话题
  ID_11367: 11367, // 我的主页-帖子详情-话题
  ID_11368: 11368, // 弹窗-帖子详情-分享-微信
  ID_11369: 11369, // 弹窗-帖子详情-分享-朋友圈
  ID_11370: 11370, // 弹窗-帖子详情-分享-qq
  ID_11371: 11371, // 弹窗-帖子详情-分享-微博
  ID_11372: 11372, // 弹窗-帖子详情-分享-钉钉
  ID_11373: 11373, // 弹窗-帖子详情-分享-好友
  ID_11374: 11374, // 弹窗-帖子详情-分享-举报页
  ID_11375: 11375, // 弹窗-帖子详情-分享-屏蔽
  ID_11376: 11376, // 弹窗-帖子详情-分享-复制链接
  ID_11377: 11377, // 弹窗-帖子详情-视频详情-分享
  ID_11378: 11378, // 弹窗-帖子详情-视频详情-分享-微信
  ID_11379: 11379, // 弹窗-帖子详情-视频详情-分享-朋友圈
  ID_11380: 11380, // 弹窗-帖子详情-视频详情-分享-qq
  ID_11381: 11381, // 弹窗-帖子详情-视频详情-分享-微博
  ID_11382: 11382, // 弹窗-帖子详情-视频详情-分享-钉钉
  ID_11383: 11383, // 弹窗-帖子详情-视频详情-分享-好友
  ID_11384: 11384, // 弹窗-帖子详情-视频详情-分享-举报页
  ID_11385: 11385, // 弹窗-帖子详情-视频详情-分享-屏蔽
  ID_11386: 11386, // 弹窗-帖子详情-视频详情-分享-复制链接
  ID_11387: 11387, // 系统通知-帖子详情-分享-微信
  ID_11388: 11388, // 系统通知-帖子详情-分享-朋友圈
  ID_11389: 11389, // 系统通知-帖子详情-分享-qq
  ID_11390: 11390, // 系统通知-帖子详情-分享-微博
  ID_11391: 11391, // 系统通知-帖子详情-分享-钉钉
  ID_11392: 11392, // 系统通知-帖子详情-分享-好友
  ID_11393: 11393, // 系统通知-帖子详情-分享-举报页
  ID_11394: 11394, // 系统通知-帖子详情-分享-屏蔽
  ID_11395: 11395, // 系统通知-帖子详情-分享-复制链接
  ID_11396: 11396, // 系统通知-帖子详情-分享
  ID_11397: 11397, // 系统通知-帖子详情-视频详情-分享
  ID_11398: 11398, // 系统通知-帖子详情-视频详情-分享-微信
  ID_11399: 11399, // 系统通知-帖子详情-视频详情-分享-朋友圈
  ID_11400: 11400, // 系统通知-帖子详情-视频详情-分享-qq
  ID_11401: 11401, // 系统通知-帖子详情-视频详情-分享-微博
  ID_11402: 11402, // 系统通知-帖子详情-视频详情-分享-钉钉
  ID_11403: 11403, // 系统通知-帖子详情-视频详情-分享-好友
  ID_11404: 11404, // 系统通知-帖子详情-视频详情-分享-举报页
  ID_11405: 11405, // 系统通知-帖子详情-视频详情-分享-屏蔽
  ID_11406: 11406, // 系统通知-帖子详情-视频详情-分享-复制链接
  ID_11407: 11407, // 互动消息-帖子详情-分享-微信
  ID_11408: 11408, // 互动消息-帖子详情-分享-朋友圈
  ID_11409: 11409, // 互动消息-帖子详情-分享-qq
  ID_11410: 11410, // 互动消息-帖子详情-分享-微博
  ID_11411: 11411, // 互动消息-帖子详情-分享-钉钉
  ID_11412: 11412, // 互动消息-帖子详情-分享-好友
  ID_11413: 11413, // 互动消息-帖子详情-分享-举报页
  ID_11414: 11414, // 互动消息-帖子详情-分享-屏蔽
  ID_11415: 11415, // 互动消息-帖子详情-分享-复制链接
  ID_11416: 11416, // 互动消息-帖子详情-分享
  ID_11417: 11417, // 互动消息-帖子详情-视频详情-分享
  ID_11418: 11418, // 互动消息-帖子详情-视频详情-分享-微信
  ID_11419: 11419, // 互动消息-帖子详情-视频详情-分享-朋友圈
  ID_11420: 11420, // 互动消息-帖子详情-视频详情-分享-qq
  ID_11421: 11421, // 互动消息-帖子详情-视频详情-分享-微博
  ID_11422: 11422, // 互动消息-帖子详情-视频详情-分享-钉钉
  ID_11423: 11423, // 互动消息-帖子详情-视频详情-分享-好友
  ID_11424: 11424, // 互动消息-帖子详情-视频详情-分享-举报页
  ID_11425: 11425, // 互动消息-帖子详情-视频详情-分享-屏蔽
  ID_11426: 11426, // 互动消息-帖子详情-视频详情-分享-复制链接
  ID_11427: 11427, // 聊天-帖子详情-分享-微信
  ID_11428: 11428, // 聊天-帖子详情-分享-朋友圈
  ID_11429: 11429, // 聊天-帖子详情-分享-qq
  ID_11430: 11430, // 聊天-帖子详情-分享-微博
  ID_11431: 11431, // 聊天-帖子详情-分享-钉钉
  ID_11432: 11432, // 聊天-帖子详情-分享-好友
  ID_11433: 11433, // 聊天-帖子详情-分享-举报页
  ID_11434: 11434, // 聊天-帖子详情-分享-屏蔽
  ID_11435: 11435, // 聊天-帖子详情-分享-复制链接
  ID_11436: 11436, // 聊天-帖子详情-分享
  ID_11437: 11437, // 聊天-帖子详情-视频详情-分享
  ID_11438: 11438, // 聊天-帖子详情-视频详情-分享-微信
  ID_11439: 11439, // 聊天-帖子详情-视频详情-分享-朋友圈
  ID_11440: 11440, // 聊天-帖子详情-视频详情-分享-qq
  ID_11441: 11441, // 聊天-帖子详情-视频详情-分享-微博
  ID_11442: 11442, // 聊天-帖子详情-视频详情-分享-钉钉
  ID_11443: 11443, // 聊天-帖子详情-视频详情-分享-好友
  ID_11444: 11444, // 聊天-帖子详情-视频详情-分享-举报页
  ID_11445: 11445, // 聊天-帖子详情-视频详情-分享-屏蔽
  ID_11446: 11446, // 聊天-帖子详情-视频详情-分享-复制链接
  ID_11447: 11447, // 资讯-专栏-类目-列表帖子-帖子详情-分享-微信
  ID_11448: 11448, // 资讯-专栏-类目-列表帖子-帖子详情-分享-朋友圈
  ID_11449: 11449, // 资讯-专栏-类目-列表帖子-帖子详情-分享-qq
  ID_11450: 11450, // 资讯-专栏-类目-列表帖子-帖子详情-分享-微博
  ID_11451: 11451, // 资讯-专栏-类目-列表帖子-帖子详情-分享-钉钉
  ID_11452: 11452, // 资讯-专栏-类目-列表帖子-帖子详情-分享-好友
  ID_11453: 11453, // 资讯-专栏-类目-列表帖子-帖子详情-分享-举报页
  ID_11454: 11454, // 资讯-专栏-类目-列表帖子-帖子详情-分享-屏蔽
  ID_11455: 11455, // 资讯-专栏-类目-列表帖子-帖子详情-分享-复制链接
  ID_11456: 11456, // 资讯-专栏-列表帖子-帖子详情-分享-微信
  ID_11457: 11457, // 资讯-专栏-列表帖子-帖子详情-分享-朋友圈
  ID_11458: 11458, // 资讯-专栏-列表帖子-帖子详情-分享-qq
  ID_11459: 11459, // 资讯-专栏-列表帖子-帖子详情-分享-微博
  ID_11460: 11460, // 资讯-专栏-列表帖子-帖子详情-分享-钉钉
  ID_11461: 11461, // 资讯-专栏-列表帖子-帖子详情-分享-好友
  ID_11462: 11462, // 资讯-专栏-列表帖子-帖子详情-分享-举报页
  ID_11463: 11463, // 资讯-专栏-列表帖子-帖子详情-分享-屏蔽
  ID_11464: 11464, // 资讯-专栏-列表帖子-帖子详情-分享-复制链接
  ID_11465: 11465, // 活动-活动进行中-帖子-帖子详情-分享-微信
  ID_11466: 11466, // 活动-活动进行中-帖子-帖子详情-分享-朋友圈
  ID_11467: 11467, // 活动-活动进行中-帖子-帖子详情-分享-qq
  ID_11468: 11468, // 活动-活动进行中-帖子-帖子详情-分享-微博
  ID_11469: 11469, // 活动-活动进行中-帖子-帖子详情-分享-钉钉
  ID_11470: 11470, // 活动-活动进行中-帖子-帖子详情-分享-好友
  ID_11471: 11471, // 活动-活动进行中-帖子-帖子详情-分享-举报页
  ID_11472: 11472, // 活动-活动进行中-帖子-帖子详情-分享-屏蔽
  ID_11473: 11473, // 活动-活动进行中-帖子-帖子详情-分享-复制链接
  ID_11474: 11474, // 活动-中奖公告-帖子-帖子详情-分享-微信
  ID_11475: 11475, // 活动-中奖公告-帖子-帖子详情-分享-朋友圈
  ID_11476: 11476, // 活动-中奖公告-帖子-帖子详情-分享-qq
  ID_11477: 11477, // 活动-中奖公告-帖子-帖子详情-分享-微博
  ID_11478: 11478, // 活动-中奖公告-帖子-帖子详情-分享-钉钉
  ID_11479: 11479, // 活动-中奖公告-帖子-帖子详情-分享-好友
  ID_11480: 11480, // 活动-中奖公告-帖子-帖子详情-分享-举报页
  ID_11481: 11481, // 活动-中奖公告-帖子-帖子详情-分享-屏蔽
  ID_11482: 11482, // 活动-中奖公告-帖子-帖子详情-分享-复制链接
  ID_11483: 11483, // 活动-中奖公告-全部-帖子-帖子详情-分享-微信
  ID_11484: 11484, // 活动-中奖公告-全部-帖子-帖子详情-分享-朋友圈
  ID_11485: 11485, // 活动-中奖公告-全部-帖子-帖子详情-分享-qq
  ID_11486: 11486, // 活动-中奖公告-全部-帖子-帖子详情-分享-微博
  ID_11487: 11487, // 活动-中奖公告-全部-帖子-帖子详情-分享-钉钉
  ID_11488: 11488, // 活动-中奖公告-全部-帖子-帖子详情-分享-好友
  ID_11489: 11489, // 活动-中奖公告-全部-帖子-帖子详情-分享-举报页
  ID_11490: 11490, // 活动-中奖公告-全部-帖子-帖子详情-分享-屏蔽
  ID_11491: 11491, // 活动-中奖公告-全部-帖子-帖子详情-分享-复制链接
  ID_11492: 11492, // 活动-历史活动-帖子-帖子详情-分享-微信
  ID_11493: 11493, // 活动-历史活动-帖子-帖子详情-分享-朋友圈
  ID_11494: 11494, // 活动-历史活动-帖子-帖子详情-分享-qq
  ID_11495: 11495, // 活动-历史活动-帖子-帖子详情-分享-微博
  ID_11496: 11496, // 活动-历史活动-帖子-帖子详情-分享-钉钉
  ID_11497: 11497, // 活动-历史活动-帖子-帖子详情-分享-好友
  ID_11498: 11498, // 活动-历史活动-帖子-帖子详情-分享-举报页
  ID_11499: 11499, // 活动-历史活动-帖子-帖子详情-分享-屏蔽
  ID_11500: 11500, // 活动-历史活动-帖子-帖子详情-分享-复制链接
  ID_11501: 11501, // 活动帖-详情页-分享-举报
  ID_11502: 11502, // 活动帖-详情页-分享-屏蔽
  ID_11503: 11503, // 弹窗-帖子详情-分享
  ID_30266: 30266, // 即刻-默认
  ID_30267: 30267, // 即刻-最新
  ID_30268: 30268, // 即刻-关注
  ID_11507: 11507, // 他人主页-帖子详情-分享复制链接
  ID_11508: 11508, // 热点-帖子列表-视频详情-分享
  ID_11509: 11509, // 热点-帖子详情-分享
  ID_11510: 11510, // 热点-帖子详情-视频详情-分享
  ID_11511: 11511, // 活动帖-详情页-分享
  ID_11512: 11512, // 资讯-专栏-类目-列表帖子-帖子详情-分享
  ID_11513: 11513, // 资讯-专栏-列表帖子-帖子详情-分享
  ID_11514: 11514, // 他人个人主页-发帖-帖子详情-分享
  ID_11537: 11537, // 车辆信息页-点击进入
  ID_11538: 11538, // 车辆信息页-点击滑动
  ID_11539: 11539, // 收起展开固件详情
  ID_11540: 11540, // 用户点击复制按钮
  ID_11541: 11541, // 用户编辑车辆名称
  ID_20024: 20024, // APP启动
  ID_10786: 10786, // 灵敏度设置变更
  ID_10787: 10787, // 推送点击行为
  ID_10788: 10788, // 设置页面访问
  ID_10789: 10789, // 绑定并充值智能服务
  ID_10780: 10780, // 点击首页发起绑定
  ID_10782: 10782, // 点击胎压功能页发起绑定
  ID_10783: 10783, // 绑定成功
  ID_10781: 10781, // 点击首页胎压模块
  ID_10785: 10785, // 查看帮助提醒
  ID_10784: 10784, // 解绑胎压传感器
  ID_40260: 40260, // 档位状态变化时（P/N/READY切换）
  ID_40261: 40261, // 边撑感应状态设置操作（开启/关闭）
  ID_40262: 40262, // 座垫感应状态设置操作（开启/关闭）
  ID_40263: 40263, // 边撑感应状态变化（开启/关闭）
  ID_40264: 40264, // 座垫感应状态变化（开启/关闭）
  ID_40265: 40265, // 用户尝试进入READY状态（拧转把/按启动键）
  ID_40266: 40266, // 简易骑行功能开启/关闭操作
  ID_40267: 40267, // 简易骑行功能状态变化开启/关闭
  ID_40268: 40268, // 边撑落下时骑行（速度>0）
  ID_11515: 11515, // 维修保养-点击
  ID_11516: 11516, // 维修保养-故障保修-点击
  ID_11517: 11517, // 维修保养-预约保养-点击
  ID_11518: 11518, // 维修保养-我的服务-点击
  ID_11519: 11519, // 骑行保障-点击
  ID_11520: 11520, // 骑行保障-温馨提示-已阅读-点击
  ID_11521: 11521, // 骑行保障-温馨提示-暂不购买-点击
  ID_11522: 11522, // motoPlay-入口点击
  ID_11523: 11523, // motoPlay-连接状态变更
  ID_11524: 11524, // motoPlay-自动投屏设置点击
  ID_11525: 11525, // motoPlay-自动巡航设置点击
  ID_11526: 11526, // motoPlay-添加途径点
  ID_11527: 11527, // motoPlay-启动导航
  ID_11528: 11528, // motoPlay-导航状态变化
  ID_11529: 11529, // motoPlay-断开连接
  ID_11530: 11530, // motoPlay-家/公司/收藏夹点击
  ID_11531: 11531, // motoPlay-热门poi点击
  ID_11532: 11532, // motoPlay-高德地址识别
  ID_11533: 11533, // motoPlay-限行设置变更
  ID_11534: 11534, // motoPlay-反控功能操作
  ID_20239: 20239, // 氮气加速-车辆设置列表页-曝光
  ID_11535: 11535, // 氮气加速-车辆设置列表页-点击
  ID_11536: 11536, // 氮气加速-车辆设置详情页-切换按钮点击
  ID_30269: 30269, // 离开车辆信息页
  ID_11542: 11542, // 极市商品详情-立即购买-立即支付-确认支付
  ID_11543: 11543, // 极市商品详情-立即购买-立即支付-取消支付
  ID_11544: 11544, // 极市商品详情-立即购买-立即支付-确认支付-复制链接
  ID_11545: 11545, // 极市商品详情-立即购买-立即支付-确认支付-复制卡号
  ID_11546: 11546, // 极市商品详情-立即购买-立即支付-确认支付-复制卡密
  ID_11547: 11547, // 极市商品详情-立即购买-立即支付-确认支付-兑换流程
  ID_11548: 11548, // 极市商品详情-立即购买-立即支付-确认支付-兑换流程-复制链接
  ID_11549: 11549, // 极市商品详情-立即购买-立即支付-确认支付-兑换流程-复制卡号
  ID_11550: 11550, // 极市商品详情-立即购买-立即支付-确认支付-兑换流程-复制卡密
  ID_11551: 11551, // 我的订单-商城订单-虚拟卡券-兑换流程
  ID_11552: 11552, // 我的订单-商城订单-虚拟卡券-复制链接
  ID_11553: 11553, // 我的订单-商城订单-虚拟卡券-复制卡号
  ID_11554: 11554, // 我的订单-商城订单-虚拟卡券-复制卡密
  ID_11555: 11555, // 我的订单-商城订单-虚拟卡券-兑换流程-复制链接
  ID_11556: 11556, // 我的订单-商城订单-虚拟卡券-兑换流程-复制卡号
  ID_11557: 11557, // 我的订单-商城订单-虚拟卡券-兑换流程-复制卡密
  ID_11559: 11559, // 年度报告-音乐-开启
  ID_11560: 11560, // 年度报告-音乐-关闭
  ID_11561: 11561, // 年度报告-顶部分享
  ID_11562: 11562, // 年度报告-顶部分享-分享渠道
  ID_11563: 11563, // 年度报告-MotoPlay-调研
  ID_11564: 11564, // 年度报告-标签页-分享
  ID_11565: 11565, // 年度报告-标签页分享-分享渠道
  ID_11566: 11566, // 年度报告-标签页分享-再看一遍
  ID_11567: 11567, // 年度报告-标签页分享-立下26年骑行Flag
  ID_11568: 11568, // 年度报告-标签页分享-查看26年骑行Flag
  ID_11569: 11569, // 年度报告-截图
  ID_30270: 30270, // 年度报告-用户浏览页面时长
};

// 埋点入口
export const EVENT_FROMS = {
  MESSAGE_PUSH: { key: 'MESSAGE_PUSH', value: '消息推送' }, // 消息推送
  MESSAGE_PUSH_ACTIVITY: { key: 'MESSAGE_PUSH_ACTIVITY', value: '消息推送-活动通知' },
  MESSAGE_PUSH_SYSTEM: { key: 'MESSAGE_PUSH_SYSTEM', value: '消息推送-系统消息' }, // 消息推送-系统消息
  MESSAGE_PUSH_LINK: { key: 'MESSAGE_PUSH_LINK', value: '消息推送-外部链接' }, // 消息推送-外部链接
  HOME_POPUP: { KEY: 'HOME_POPUP', value: '首页弹窗' }, // 首页弹窗
  SOCIAL_BANNER: { key: 'SOCIAL_BANNER', value: '社区Banner' }, // 社区Banner
};

// 分享埋点入口
export const EVENT_SHARE_FROMS = {
  SHARE_QQ: { key: 'SHARE_QQ', value: 'QQ' }, // QQ
  SHARE_WECHART: { key: 'SHARE_WECHART', value: '微信好友' }, // 微信好友
  SHARE_WECHART_MOMENTS: { key: 'SHARE_WECHART_MOMENTS', value: '微信朋友圈' }, // 微信朋友圈
  SHARE_WEIBO: { key: 'SHARE_WEIBO', value: '新浪微博' }, // 新浪微博
  SHARE_DINGTALK: { key: 'SHARE_DINGTALK', value: '钉钉' }, // 钉钉
  SHARE_ZEEHO: { key: 'SHARE_ZEEHO', value: 'ZEEHO好友' }, // ZEEHO好友
  SHARE_ZEEHO_MOMENTS: { key: 'SHARE_ZEEHO_MOMENTS', value: 'ZEEHO极客' }, // ZEEHO极客
  SHARE_ALBUM: { key: 'SHARE_ALBUM', value: '保存相册' }, // 保存相册
  SHARE_COPY: { key: 'SHARE_COPY', value: '复制链接' }, // 复制链接
};

// 埋点出口-年报2025
export const EVENT_TO_YEAR_REPORT_2025 = {
  0: { key: 'START', value: '起始页面' }, // 起始页
  1: { key: 'REGISTER', value: '注册/绑车页面' }, // 注册/绑车页
  2: { key: 'RIDE_TOTAL', value: '骑行总览页面' }, // 骑行总览
  3: { key: 'RIDE_SINGLE', value: '单次骑行页' }, // 单次骑行
  4: { key: 'RIDE_DURATION', value: '骑行时段页面' }, // 骑行时段
  5: { key: 'RIDE_WEEKEND', value: '周末骑行页面' }, // 周末骑行
  6: { key: 'DRIVE_MODE', value: '驾驶模式页面' }, // 驾驶模式
  7: { key: 'SCREEN_NAVIGATION_SOUND', value: '导航/游戏/自定义音效页面' }, // 投屏/导航/自定义音效
  8: { key: 'RIDE_SECURITY', value: '骑行安全页面' }, // 骑行安全
  9: { key: 'UNLOCK_SHARE', value: '解锁/分享页面' }, // 解锁/分享
  10: { key: 'FOLLOW', value: '签到/关注/粉丝页面' }, // 签到/关注/粉丝
  11: { key: 'SOCIAL', value: '社区相关页面' }, // 社区相关页
  12: { key: 'INTEGRAL_CONSUMPTION', value: '积分消费页面' }, // 积分消费页
  13: { key: 'LABEL', value: '标签页面' }, // 标签页
};

// 权限类型
export const NATIVE_AUTHORITIZATION_TYPES = {
  LOGIN: 'LOGIN',
};
